angular.module("ainapp")
    .controller("addSalesQuotationController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
         "VoucherValidationService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService,VoucherValidationService) {

            $scope.VoucherName = "Sales Quotation";
            $scope.IsSales = true;

            $scope.PageName = "Add Sales Quotation";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.getExtramasters();


            $scope.TableDesign = {};
            $scope.ColumnWidth = null;
            MainService.TableDesignsbyVoucher("Sales Quotation").then(function (response) {
                  if (response.data != null) {
                    $scope.TableDesign = response.data;
                    $scope.ColumnWidth = JSON.parse(response.data.ColumnWidth);
                }
            });

            $scope.TabDesign = {};
            MainService.TabDesignsbyType("Sales Quotation").then(function (response) {
                $scope.TabDesign = response.data;
            });

            $scope.PrintSetting = {};
            MainService.PrintSettingsbyType("Sales Quotation").then(function (response) {
                $scope.PrintSetting = response.data;
            });

             $scope.loadWarehouse2 = function (data) {
            $scope.Warehouse2s = [];
            if ($scope.CompanyProfile.WarehouseLevel > 1) {
                MainService.WarehousesInDropdownByWId(data.WarehouseId).then(function (response) {
                    $scope.Warehouse2s = response.data;
                })
            }
        }

            $scope.voucherno = {
                number: "",
            };
            $scope.VoucherNoAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "VoucherNumber",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.SalesQuotationInVoucherAuto(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.VoucherAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "VoucherNumber",
                dataTextField: "VoucherNumber",
                filter: "contains",
                placeholder: "Search Voucher No",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.voucherno.number = data.VoucherNumber;
                    $scope.$apply();
                    $scope.loadVoucher(data.Id);
                },
                minLength: 2,
                dataSource: $scope.VoucherNoAutocompleteDataSource
            };

            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.getSalesQuotationbyId(data).then(function (response) {
                    if (response.data) {
                        if ($scope.isClone) {
                            MainService.GetNextSalesQuotationNo().then(function (response2) {
                                response.data[0].VoucherNumber = response2.data;
                                response.data[0].Id = "";
                                response.data[0].Date = new Date();
                                angular.forEach(response.data[0].SalesQuotationDetails, function (e) {
                                    e.Id = "";
                                })
                                           $scope.UpdateDetails(response.data[0], true);
                            });
                            $scope.isClone = false;
                        } else {
                            $scope.UpdateDetails(response.data[0]);
                        }
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("NetworkError");
                })
            }

            $scope.cloneVoucher = function () {
                $scope.isClone = true;
                $scope.loadVoucher($scope.ISalesInvoice.Id);
            }


            $scope.UpdateDetails = function (data, reloadcost) {

                $scope.ISalesInvoice = data;
                if ($scope.ISalesInvoice.PaymentType == "" || $scope.ISalesInvoice.PaymentType == null) {
                    $scope.ISalesInvoice.PaymentType = $scope.VoucherSet.PaymentType;
                }
                $scope.VoucherExtraTables = $scope.ISalesInvoice.VoucherExtraTables;
                $scope.VoucherDocs = data.VoucherDocs;

                if ($scope.VDesign.SkipVoucherLinkValidation == false) {
                    $scope.IsLinkedScreen = false;
                    if ($scope.ISalesInvoice.LinkedRefNos == null) {
                        $scope.IsLinkedScreen = false;
                    } else if ($scope.ISalesInvoice.LinkedRefNos.length > 0) {
                        $scope.IsLinkedScreen = true;
                    }
                }

                $scope.ISalesInvoice.Date = new Date($scope.ISalesInvoice.Date);

                if ($scope.ISalesInvoice.SupplierBillDate != null) {
                    $scope.ISalesInvoice.SupplierBillDate = new Date($scope.ISalesInvoice.SupplierBillDate);
                }
                if ($scope.ISalesInvoice.DeliveryDate != null) {
                    $scope.ISalesInvoice.DeliveryDate = new Date($scope.ISalesInvoice.DeliveryDate);
                }
                if ($scope.ISalesInvoice.ReturnDate != null) {
                    $scope.ISalesInvoice.ReturnDate = new Date($scope.ISalesInvoice.ReturnDate);
                }

                if ($scope.ISalesInvoice.Field16 != null) {
                    $scope.ISalesInvoice.Field16 = new Date($scope.ISalesInvoice.Field16);
                }
                if ($scope.ISalesInvoice.Field17 != null) {
                    $scope.ISalesInvoice.Field17 = new Date($scope.ISalesInvoice.Field17);
                }
                if ($scope.ISalesInvoice.Field18 != null) {
                    $scope.ISalesInvoice.Field18 = new Date($scope.ISalesInvoice.Field18);
                }
                if ($scope.ISalesInvoice.Field19 != null) {
                    $scope.ISalesInvoice.Field19 = new Date($scope.ISalesInvoice.Field19);
                }
                if ($scope.ISalesInvoice.Field20 != null) {
                    $scope.ISalesInvoice.Field20 = new Date($scope.ISalesInvoice.Field20);
                }

                angular.forEach(data.SalesQuotationCosts, function (e) {
                    angular.forEach($scope.CostCenters, function (a) {
                        if (e.CostCenter.ParentId == a.CostCenterId) {
                            a.SelectedCostCenterId = e.CostCenter.Id;
                        }
                    })
                })

                $scope.rowId = 0;

                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {

                    if ($scope.VoucherSet.IsLoadProductUnitOnly) {
                        MainService.GetProductUnitsInDropdown(e.ProductId).then(function (response) {
                            if (response.data.length > 0) {
                                e.Units = response.data;
                            } else {
                                e.Units = $scope.Units;
                            }
                        })
                    } else {
                        e.Units = $scope.Units;
                    }
$scope.loadWarehouse2(e);

                    if (e.Field16 != null) {
                        e.Field16 = new Date(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.Field17 = new Date(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.Field18 = new Date(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.Field19 = new Date(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.Field20 = new Date(e.Field20);
                    }

                    var costs = angular.copy($scope.CostCenters);
                    if (e.SalesQuotationCosts.length > 0) {
                        angular.forEach(e.SalesQuotationCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            e.CostCenters = angular.copy(costs);
                        })
                    } else {
                        e.CostCenters = angular.copy($scope.CostCenters);
                    }

                    e.rowId = $scope.rowId++;

                     if(reloadcost == true){
                        $scope.click(e,1);
                    }

                });

                if (data.SalesQuotationDetails.length <= 5) {
                    var temp2 = 5 - data.SalesQuotationDetails.length;
                    for (var i = 0; i < temp2; i++) {
                        $scope.InsertRow(1);
                    }
                }

                $scope.FilterCustomerCostCenters();
                $scope.CalculateTotals();
                $scope.getCustomerContacts();

                if ($scope.RearrangeReqired == true) {
                    $scope.rearrangeTableCells($scope.tableReorderColumnArray);
                }
            }


            //// linking //// 

            $scope.LinkVocuhers = function () {
                if ($scope.ISalesInvoice.CustomerId == "") {
                    toastr.info("Select Customer..!!");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.VoucherLinkArray = [];
                    MainService.GetAllPendingVouchersForLinking($scope.ISalesInvoice.CustomerId, "Sales Quotation").then(function (response) {
                        if (response.data != null) {
                            if (response.data.length > 0) {
                                $scope.VoucherLinkArray = response.data;
                                $scope.viewLinkname = $scope.VoucherLinkArray[0].VoucherName;
                                $('#LinkView').modal('show');
                            } else {
                                toastr.error("Linking Not Added");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
            }

            $scope.LinkDetailVocuhers = function () {
                if ($scope.ISalesInvoice.CustomerId == "") {
                    toastr.info("Select Customer..!!");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.VoucherLinkArray = [];
                    MainService.GetAllPendingVoucherDetailsForLinking($scope.ISalesInvoice.CustomerId, "Sales Quotation").then(function (response) {
                        if (response.data != null) {
                            if (response.data.length > 0) {
                                $scope.VoucherLinkArray = response.data;
                                $scope.viewLinkname = $scope.VoucherLinkArray[0].VoucherName;
                                $('#DetailLinkView').modal('show');
                            } else {
                                toastr.error("Linking Not Added");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }
            }

            $scope.LinkVocuhersCost = function (costId) {
                if (costId > 0) {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.VoucherLinkArray = [];
                    MainService.GetAllPendingVouchersForLinkingCost(costId, "Sales Quotation").then(function (response) {
                        if (response.data != null) {
                            if (response.data.length > 0) {
                                $scope.IsVoucherLinkCost = true;
                                $scope.VCCostcenterId = costId;
                                $scope.VoucherLinkArray = response.data;
                                $scope.viewLinkname = $scope.VoucherLinkArray[0].VoucherName;
                                $('#LinkView').modal('show');
                            } else {
                                toastr.error("Linking Not Added");
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                } else {
                    toastr.warning("Please Select Cost Center");
                }
            }

            $scope.changeLinkView = function (data) {
                $scope.viewLinkname = data.VoucherName;
                $scope.mvl.SelectAllMVlinks = false;
            }

            $scope.selectAllVoucherDetailLinks = function () {
                angular.forEach($scope.VoucherLinkArray, function (e) {
                    if ($scope.viewLinkname == e.VoucherName) {
                        angular.forEach(e.CommonVoucherDetails, function (a) {
                            a.IsSelect = !a.IsSelect;
                        })
                    }
                })
            }


            $scope.showUpdatePreview = function (data) {
                angular.forEach(data.CommonVoucherDetails, function (e) {
                    e.QtyToLink = angular.copy(e.BalanceQty);
                    e.PerQtyToLink = 100;
                    var x = ((e.LinkedQty - e.Quantity) / e.Quantity) * 100;

                    e.LinkedPer = 100 - (Math.abs($scope.roundOffValue(x)));
                    e.IsSelect = false;
                })
                data.SelectAll = false;
                $scope.LinkPreviewData = data;
                $scope.loadLinkheader = true;
                $('#LinkPreview').modal('show');
            }

            $scope.updateLinkPer = function (data) {

                data.QtyToLink = data.BalanceQty * (data.PerQtyToLink / 100);
            }

            $scope.selectAllVoucherLinks = function () {
                angular.forEach($scope.LinkPreviewData.CommonVoucherDetails, function (e) {
                    if ($scope.LinkPreviewData.SelectAll) {
                        e.IsSelect = true;
                    } else {
                        e.IsSelect = false;
                    }
                })
            }

            $scope.UpdateLinkingDetails2 = function () {
                angular.forEach($scope.VoucherLinkArray, function (e) {
                    if ($scope.viewLinkname == e.VoucherName) {
                        $scope.LinkPreviewData = e;
                        $scope.loadLinkheader = false;
                        $scope.preLinkcustomer = angular.copy($scope.ISalesInvoice.Customer);
                        $scope.UpdateLinkingDetails();
                    }
                })
            }

            $scope.UpdateLinkingDetails = function () {

                var data = $scope.LinkPreviewData;
                var isvalid = true;
                var isSelected = false;

                angular.forEach($scope.LinkPreviewData.CommonVoucherDetails, function (e) {
                    if (e.IsSelect) {
                        isSelected = true;
                        if (e.BalanceQty - e.QtyToLink < 0) {
                            isvalid = false;
                        }
                        if (e.QtyToLink == 0 || e.QtyToLink == undefined) {
                            isvalid = false;
                        }
                    }
                })

                if (isSelected == false) {
                    toastr.warning("Please Select Products To Link!");
                } else if (isvalid == false) {
                    toastr.warning("Linked Quantity More Than Available Quantity!");
                } else {

                    var predata = angular.copy($scope.ISalesInvoice);
                    $scope.ISalesInvoice = angular.copy(data);
                    $scope.ISalesInvoice.VoucherNumber = $scope.traceNo;

                    if ($scope.loadLinkheader == false) {
                        $scope.ISalesInvoice.Customer = angular.copy($scope.preLinkcustomer);
                        $scope.ISalesInvoice.CustomerId = angular.copy($scope.preLinkcustomer.Id);
                        $scope.ISalesInvoice.EndLetterDescription = predata.EndLetterDescription;
                        $scope.ISalesInvoice.IntroLetterDescription = predata.IntroLetterDescription;
                        $scope.ISalesInvoice.VoucherNumber = predata.VoucherNumber;
                        $scope.ISalesInvoice.BaseCurrencyId = predata.BaseCurrencyId;
                        $scope.preLinkcustomer = {};
                    }

                    $scope.ISalesInvoice.Id = "";
                    $scope.ISalesInvoice.LinkedRefNos = "";
                    $scope.ISalesInvoice.LinkEnquiryId = data.Id;
                    $scope.ISalesInvoice.LinkVoucherId = $stateParams.LinkVoucherId;

                    $scope.ISalesInvoice.SalesQuotationDetails = [];
                    $scope.ISalesInvoice.CommonVoucherDetails = [];
                    $scope.ISalesInvoice.CommonVoucherCosts = [];

                    if (1 == 1) {
                        $scope.ISalesInvoice.Date = new Date();

                        if ($scope.ISalesInvoice.SupplierBillDate != null) {
                            $scope.ISalesInvoice.SupplierBillDate = new Date($scope.ISalesInvoice.SupplierBillDate);
                        }
                        if ($scope.ISalesInvoice.DeliveryDate != null) {
                            $scope.ISalesInvoice.DeliveryDate = new Date($scope.ISalesInvoice.DeliveryDate);
                        }
                        if ($scope.ISalesInvoice.ReturnDate != null) {
                            $scope.ISalesInvoice.ReturnDate = new Date($scope.ISalesInvoice.ReturnDate);
                        }

                        if ($scope.ISalesInvoice.Field16 != null) {
                            $scope.ISalesInvoice.Field16 = new Date($scope.ISalesInvoice.Field16);
                        }
                        if ($scope.ISalesInvoice.Field17 != null) {
                            $scope.ISalesInvoice.Field17 = new Date($scope.ISalesInvoice.Field17);
                        }
                        if ($scope.ISalesInvoice.Field18 != null) {
                            $scope.ISalesInvoice.Field18 = new Date($scope.ISalesInvoice.Field18);
                        }
                        if ($scope.ISalesInvoice.Field19 != null) {
                            $scope.ISalesInvoice.Field19 = new Date($scope.ISalesInvoice.Field19);
                        }
                        if ($scope.ISalesInvoice.Field20 != null) {
                            $scope.ISalesInvoice.Field20 = new Date($scope.ISalesInvoice.Field20);
                        }

                    }

                    var maiCosts = angular.copy($scope.CostCenters);
                    angular.forEach(data.CommonVoucherCosts, function (e) {
                        angular.forEach(maiCosts, function (a) {
                            if (e.CostCenter.ParentId == a.CostCenterId) {
                                a.SelectedCostCenterId = e.CostCenter.Id;
                            }
                        })
                    })

                    $scope.rowId = 0;

                    angular.forEach(data.CommonVoucherDetails, function (e) {
                        if (e.IsSelect) {

                            if ($scope.VoucherSet.IsLoadProductUnitOnly) {
                                MainService.GetProductUnitsInDropdown(e.ProductId).then(function (response) {
                                    if (response.data.length > 0) {
                                        e.Units = response.data;
                                    } else {
                                        e.Units = $scope.Units;
                                    }
                                })
                            } else {
                                e.Units = $scope.Units;
                            }
$scope.loadWarehouse2(e);

                            if (e.Field16 != null) {
                                e.Field16 = new Date(e.Field16);
                            }
                            if (e.Field17 != null) {
                                e.Field17 = new Date(e.Field17);
                            }
                            if (e.Field18 != null) {
                                e.Field18 = new Date(e.Field18);
                            }
                            if (e.Field19 != null) {
                                e.Field19 = new Date(e.Field19);
                            }
                            if (e.Field20 != null) {
                                e.Field20 = new Date(e.Field20);
                            }


                            var detail = angular.copy(e);

                            detail.Id = "";
                            detail.Quantity = e.QtyToLink;
                            var x = ((e.QtyToLink - e.Quantity) / e.Quantity) * 100;
                            detail.LinkPer = 100 - (Math.abs($scope.roundOffValue(x)));
                            detail.ActualQty = e.Quantity;

                            if (e.Remarks != undefined) {
                                detail.Remarks = e.Remarks;
                            }
                            if (e.remarks != undefined) {
                                detail.Remarks = e.remarks;
                            }
                            detail.VoucherLinkingDetail = {
                                LinkedVoucherType: $stateParams.VoucherType,
                                LinkedVoucherId: $stateParams.LinkVoucherId,
                                LinkedVoucherDetailId: e.Id,
                                LinkedVoucherNo: data.VoucherNumber,
                                LinkedQty: e.QtyToLink,
                                ProductId: e.ProductId,
                                LinkedPer: e.PerQtyToLink,
                            }

                            if ($scope.loadLinkheader == false) {
                                detail.VoucherLinkingDetail.LinkedVoucherType = e.VoucherType;
                                detail.VoucherLinkingDetail.LinkedVoucherId = e.CommonVoucherId;
                                detail.VoucherLinkingDetail.LinkedVoucherNo = e.VoucherNumber;
                            }

                            var costs = angular.copy($scope.CostCenters);
                            if (e.CommonVoucherCosts.length > 0) {
                                angular.forEach(e.CommonVoucherCosts, function (ee) {
                                    angular.forEach(costs, function (a) {
                                        if (ee.CostCenter.ParentId == a.CostCenterId) {
                                            a.SelectedCostCenterId = ee.CostCenter.Id;
                                        }
                                    })
                                    detail.CostCenters = angular.copy(costs);
                                })
                            } else {
                                detail.CostCenters = angular.copy($scope.CostCenters);
                            }

                            detail.rowId = $scope.rowId++;
                            $scope.ISalesInvoice.SalesQuotationDetails.push(detail);

                        }
                    })


                    if ($scope.ISalesInvoice.SalesQuotationDetails.length <= 5) {
                        var temp2 = 5 - $scope.ISalesInvoice.SalesQuotationDetails.length;
                        for (var i = 0; i < temp2; i++) {
                            $scope.InsertRow(1);
                        }
                    }

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.ProductId > 0) {
                            $scope.click(e, 0);
                        }
                    })


                    $scope.CostCenters = maiCosts;
                    $('#LinkPreview').modal('hide');
                    $('#DetailLinkView').modal('hide');

                    if ($scope.VDesign.SkipVoucherLinkValidation == false) {
                        $scope.IsLinkedScreen = true;
                    }

                    $scope.FilterCustomerCostCenters();
                    $scope.CalculateTotals();

                    if ($scope.RearrangeReqired == true) {
                        $scope.rearrangeTableCells($scope.tableReorderColumnArray);
                    }

                    if ($scope.loadLinkheader != false) {
                        if ($scope.VoucherSet.IsDefaultCustomerOnLink) {
                            $scope.setDefaultAccount();
                        }
                    }
                    $scope.loadLinkheader = true;
                }

            }


            $scope.SelectAllLinkMultiVouchers = function (vname) {
                angular.forEach($scope.VoucherLinkArray, function (e) {
                    if (e.VoucherName == vname) {
                        if ($scope.mvl.SelectAllMVlinks) {
                            angular.forEach(e.CommonVouchers, function (a) {
                                a.IsSelected = true;
                            })
                        } else {
                            angular.forEach(e.CommonVouchers, function (a) {
                                a.IsSelected = false;
                            })
                        }
                    } else {

                        angular.forEach(e.CommonVouchers, function (a) {
                            a.IsSelected = false;
                        })

                    }
                })

            }

            $scope.LinkMultiVouchers = function () {

                var mainarray = [];
                angular.forEach($scope.VoucherLinkArray, function (e) {
                    var arr = [];
                    angular.forEach(e.CommonVouchers, function (a) {
                        if (a.IsSelected) {
                            arr.push(a.Id);
                        }
                    })
                    if (arr.length > 0) {
                        mainarray = arr;
                    }
                })

                var temp = {
                    Type: $scope.viewLinkname,
                    VoucherIds: mainarray,
                }

                if ($scope.IsVoucherLinkCost) {
                    temp.CostId = $scope.VCCostcenterId;
                }

                MainService.getCommonVocherLinkingDetails(temp).then(function (response) {
                    if (response.data != null) {
                        $scope.UpdateMultiLinks(response.data);
                        $('#LinkView').modal('hide');
                        $scope.IsVoucherLinkCost = false;
                        $scope.VCCostcenterId = "";
                    } else {
                        toastr.error("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

            }

            $scope.UpdateMultiLinks = function (data) {

                $scope.ISalesInvoice.SalesQuotationDetails = [];
                $scope.rowId = 0;

                angular.forEach(data, function (e) {

                    if ($scope.VoucherSet.IsLoadProductUnitOnly) {
                        MainService.GetProductUnitsInDropdown(e.ProductId).then(function (response) {
                            if (response.data.length > 0) {
                                e.Units = response.data;
                            } else {
                                e.Units = $scope.Units;
                            }
                        })
                    } else {
                        e.Units = $scope.Units;
                    }
$scope.loadWarehouse2(e);

                    if (e.Field16 != null) {
                        e.Field16 = new Date(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.Field17 = new Date(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.Field18 = new Date(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.Field19 = new Date(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.Field20 = new Date(e.Field20);
                    }

                    var detail = angular.copy(e);

                    detail.Id = "";

                    if (e.Remarks != undefined) {
                        detail.remarks = e.Remarks;
                    }
                    if (e.remarks != undefined) {
                        detail.remarks = e.remarks;
                    }

                    detail.VoucherLinkingDetail = {
                        LinkedVoucherType: e.VoucherType,
                        LinkedVoucherId: e.CommonVoucherId,
                        LinkedVoucherDetailId: e.Id,
                        LinkedVoucherNo: e.VoucherNumber,
                        LinkedQty: e.Quantity,
                        ProductId: e.ProductId,
                    }

                    var costs = angular.copy($scope.CostCenters);
                    if (e.CommonVoucherCosts.length > 0) {
                        angular.forEach(e.CommonVoucherCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            detail.CostCenters = angular.copy(costs);
                        })
                    } else {
                        detail.CostCenters = angular.copy($scope.CostCenters);
                    }

                    detail.rowId = $scope.rowId++;
                    $scope.ISalesInvoice.SalesQuotationDetails.push(detail);

                })

                if ($scope.ISalesInvoice.SalesQuotationDetails.length <= 5) {

                    var temp2 = 5 - $scope.ISalesInvoice.SalesQuotationDetails.length;

                    for (var i = 0; i < temp2; i++) {
                        $scope.InsertRow(1);
                    }
                }
                $scope.CalculateTotals();
                $scope.UpdateMultiLinkHead();

                if ($scope.RearrangeReqired == true) {
                    $scope.rearrangeTableCells($scope.tableReorderColumnArray);
                }
            }


            $scope.UpdateMultiLinkHead = function () {

                var temp = {
                    Type: $scope.viewLinkname,
                    VoucherId: $scope.ISalesInvoice.SalesQuotationDetails[0].CommonVoucherId,
                }

                MainService.getCommonVocherHeadLinkingDetails(temp).then(function (response) {
                    if (response.data != null) {

                        $scope.ISalesInvoice.Remarks = response.data.Remarks;
                        $scope.ISalesInvoice.remarks = response.data.remarks;
                        $scope.ISalesInvoice.BaseCurrencyId = response.data.BaseCurrencyId;
                        $scope.ISalesInvoice.IntroLetterDescription = response.data.IntroLetterDescription;
                        $scope.ISalesInvoice.EndLetterDescription = response.data.EndLetterDescription;
                        $scope.ISalesInvoice.Validity = response.data.Validity;
                        $scope.ISalesInvoice.ContactPerson = response.data.ContactPerson;
                        $scope.ISalesInvoice.SupplyPlace = response.data.SupplyPlace;
                        $scope.ISalesInvoice.ShippingAddress = response.data.ShippingAddress;
                        $scope.ISalesInvoice.SupplierBillNo = response.data.SupplierBillNo;
                        $scope.ISalesInvoice.SupplierQtnNo = response.data.SupplierQtnNo;
                        $scope.ISalesInvoice.WeightDimension = response.data.WeightDimension;
                        $scope.ISalesInvoice.NoOfPackages = response.data.NoOfPackages;
                        $scope.ISalesInvoice.TotalGrossWeight = response.data.TotalGrossWeight;
                        $scope.ISalesInvoice.TotalNetWeight = response.data.TotalNetWeight;
                        $scope.ISalesInvoice.EnquiryNo = response.data.EnquiryNo;
                        $scope.ISalesInvoice.OrderNo = response.data.OrderNo;
                        $scope.ISalesInvoice.WarrantyPeriod = response.data.WarrantyPeriod;
                        $scope.ISalesInvoice.DeliveryPeriod = response.data.DeliveryPeriod;
                        $scope.ISalesInvoice.DeliveryBasis = response.data.DeliveryBasis;
                        $scope.ISalesInvoice.PaymentTerms = response.data.PaymentTerms;
                        $scope.ISalesInvoice.DeliveryDate = response.data.DeliveryDate;
                        $scope.ISalesInvoice.DeliveryTime = response.data.DeliveryTime;
                        $scope.ISalesInvoice.ReturnDate = response.data.ReturnDate;
                        $scope.ISalesInvoice.ReturnTime = response.data.ReturnTime;
                        $scope.ISalesInvoice.SupplierBillDate = response.data.SupplierBillDate;
                        $scope.ISalesInvoice.CustomerPONo = response.data.CustomerPONo;
                        $scope.ISalesInvoice.SupplierPONO = response.data.SupplierPONO;
                        $scope.ISalesInvoice.Advance = response.data.Advance;
                        $scope.ISalesInvoice.AdvancePer = response.data.AdvancePer;
                        $scope.ISalesInvoice.AdvanceVAT = response.data.AdvanceVAT;
                        $scope.ISalesInvoice.EmployeeId = response.data.EmployeeId;
                        $scope.ISalesInvoice.Field1 = response.data.Field1;
                        $scope.ISalesInvoice.Field2 = response.data.Field2;
                        $scope.ISalesInvoice.Field3 = response.data.Field3;
                        $scope.ISalesInvoice.Field4 = response.data.Field4;
                        $scope.ISalesInvoice.Field5 = response.data.Field5;
                        $scope.ISalesInvoice.Field6 = response.data.Field6;
                        $scope.ISalesInvoice.Field7 = response.data.Field7;
                        $scope.ISalesInvoice.Field8 = response.data.Field8;
                        $scope.ISalesInvoice.Field9 = response.data.Field9;
                        $scope.ISalesInvoice.Field10 = response.data.Field10;
                        $scope.ISalesInvoice.Field11 = response.data.Field11;
                        $scope.ISalesInvoice.Field12 = response.data.Field12;
                        $scope.ISalesInvoice.Field13 = response.data.Field13;
                        $scope.ISalesInvoice.Field14 = response.data.Field14;
                        $scope.ISalesInvoice.Field15 = response.data.Field15;
                        $scope.ISalesInvoice.Field16 = response.data.Field16;
                        $scope.ISalesInvoice.Field17 = response.data.Field17;
                        $scope.ISalesInvoice.Field18 = response.data.Field18;
                        $scope.ISalesInvoice.Field19 = response.data.Field19;
                        $scope.ISalesInvoice.Field20 = response.data.Field20;
                        $scope.ISalesInvoice.Master1Id = response.data.Master1Id;
                        $scope.ISalesInvoice.Master2Id = response.data.Master2Id;
                        $scope.ISalesInvoice.Master3Id = response.data.Master3Id;
                        $scope.ISalesInvoice.Master4Id = response.data.Master4Id;
                        $scope.ISalesInvoice.Master5Id = response.data.Master5Id;

                        var maiCosts = angular.copy($scope.CostCenters);
                        angular.forEach(response.data.CommonVoucherCosts, function (e) {
                            angular.forEach(maiCosts, function (a) {
                                if (e.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = e.CostCenter.Id;
                                }
                            })
                        })

                        $scope.CostCenters = maiCosts;


                    } else {
                        toastr.error("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })
            }


            /////////////// Linking ....///////////////

            $scope.setDefaultProduct = function () {

                $scope.ISalesInvoice.SalesQuotationDetails[0].Product = {};
                $scope.ISalesInvoice.SalesQuotationDetails[0].Product.Name = $scope.VoucherSet.DefauldProduct.Name;
                $scope.ISalesInvoice.SalesQuotationDetails[0].Remarks = $scope.VoucherSet.DefauldProduct.Description;
                $scope.ISalesInvoice.SalesQuotationDetails[0].Product.ProductCode = $scope.VoucherSet.DefauldProduct.ProductCode;
                $scope.ISalesInvoice.SalesQuotationDetails[0].ProductId = $scope.VoucherSet.DefauldProduct.Id;
                $scope.ISalesInvoice.SalesQuotationDetails[0].UnitId = $scope.VoucherSet.DefauldProduct.UnitId;
                $scope.ISalesInvoice.SalesQuotationDetails[0].UnitPrice = $scope.VoucherSet.DefauldProduct.PurchasePrice;
                $scope.ISalesInvoice.SalesQuotationDetails[0].CountryId = $scope.VoucherSet.DefauldProduct.CountryId;
                $scope.ISalesInvoice.SalesQuotationDetails[0].BrandId = $scope.VoucherSet.DefauldProduct.BrandId;
                $scope.ISalesInvoice.SalesQuotationDetails[0].VATId = $scope.VoucherSet.DefauldProduct.VATId;
                $scope.ISalesInvoice.SalesQuotationDetails[0].UnitPrice = $scope.VoucherSet.DefauldProduct.SellPrice;
                $scope.ISalesInvoice.SalesQuotationDetails[0].Cost = $scope.VoucherSet.DefauldProduct.AveragePrice;
                $scope.ISalesInvoice.SalesQuotationDetails[0].COGS = $scope.VoucherSet.DefauldProduct.AveragePrice;
                $scope.ISalesInvoice.SalesQuotationDetails[0].NetWeight = $scope.VoucherSet.DefauldProduct.Weight;
                $scope.ISalesInvoice.SalesQuotationDetails[0].GrossWeight = $scope.VoucherSet.DefauldProduct.GrossWeight;
                $scope.ISalesInvoice.SalesQuotationDetails[0].VatType = $scope.VoucherSet.DefauldProduct.VatType;
                $scope.ISalesInvoice.SalesQuotationDetails[0].Quantity = 1;

                $scope.click($scope.ISalesInvoice.SalesQuotationDetails[0], 0)

            }

            $scope.setDefaultAccount = function () {

                $scope.ISalesInvoice.Customer = {};
                $scope.ISalesInvoice.Customer.Id = $scope.VoucherSet.DefaultCustomerId;
                $scope.ISalesInvoice.CustomerId = $scope.VoucherSet.DefaultCustomerId;
                $scope.ISalesInvoice.Customer.Name = $scope.VoucherSet.DefaultCustomer.Name;
                $scope.ISalesInvoice.Customer.MobileNo = $scope.VoucherSet.DefaultCustomer.MobileNo;
                $scope.ISalesInvoice.Customer.AccountCode = $scope.VoucherSet.DefaultCustomer.AccountCode;
                $scope.ISalesInvoice.Customer.Email = $scope.VoucherSet.DefaultCustomer.Email;
                $scope.ISalesInvoice.Customer.Address = $scope.VoucherSet.DefaultCustomer.Address;
                $scope.ISalesInvoice.Customer.TRNNo = $scope.VoucherSet.DefaultCustomer.TRNNo;
                $scope.ISalesInvoice.Customer.ContactPerson = $scope.VoucherSet.DefaultCustomer.ContactPerson;
                $scope.ISalesInvoice.Customer.ContactPersonNo = $scope.VoucherSet.DefaultCustomer.ContactPersonNo;
                $scope.ISalesInvoice.Customer.AccountContactId = $scope.VoucherSet.DefaultCustomer.AccountContactId;
                $scope.ISalesInvoice.Customer.AccountAddressId = $scope.VoucherSet.DefaultCustomer.AccountAddressId;
                $scope.ISalesInvoice.SalesQuotationDetails[0].Quantity = 1;

            }

            $scope.ContextInsertRow = function (temp) {
                $scope.InsertRow(temp);
                if ($scope.RearrangeReqired == true) {
                    $scope.rearrangeTableCells($scope.tableReorderColumnArray);
                }
            }

            $scope.InsertRow = function (temp) {

                var isLinked = false;

                if (temp != 1) {
                    if ($scope.ISalesInvoice.LinkedRefNos == null) {
                        isLinked = false;
                    } else if ($scope.ISalesInvoice.LinkedRefNos.length > 0) {
                        isLinked = true;
                    }
                }

                if (isLinked && $scope.VDesign.SkipVoucherLinkValidation == false) {
                    toastr.info("Linked Vouchers, Operation Not Permitted");
                } else {
                    var SalesQuotationDetails = {
                        Id: 0,
                        Quantity: 1,
                        Total: 0,
                        UnitPrice: 0,
                        Cost: 0,
                        TCost: 0,
                        QCostNo: 0,
                        TaxValue: 0,
                        NetTotal: 0,
                        InventoryValue: 0,
                        TaxableAmount: 0,
                        RoundOfVat: 0,
                        Discount: 0,
                        OtherCharges: 0,
                        ExtraCharges: 0,
                        VatType: "Exclusive",
                        DiscountType: "Value",
                        DiscountValue: 0,
                        Remarks: "",
                        ProductId: "",
                        CountryId: "",
                        WarehouseId: "",
                        BrandId: "",
                        VATId: "",
                        UnitId: "",
                        Product: {},
                        IsActive: true,
                        SalesQuotationDetails: [],
                        CostCenters: angular.copy($scope.CostCenters),
                        rowId: $scope.rowId++,
                        Field16: null,
                        Field17: null,
                        Field18: null,
                        Field19: null,
                        Field20: null,

                        Vat1Per: $scope.VDesign.DefaultVat1,
                        Vat2Per: $scope.VDesign.DefaultVat2,
                        Vat3Per: $scope.VDesign.DefaultVat3,
                        Vat4Per: $scope.VDesign.DefaultVat4,
                        Vat5Per: $scope.VDesign.DefaultVat5,
                        AssessableValue: 0,

                        Vat1Value: 0,
                        Vat2Value: 0,
                        Vat3Value: 0,
                        Vat4Value: 0,
                        Vat5Value: 0,
                        Units: $scope.Units,
                        Field21: 0,
                        Field22: 0,
                        Field23: 0,
                        Field24: 0,
                        Field25: 0,
                        Field26: 0,
                        Field27: 0,
                        Field28: 0,
                        Field29: 0,
                        Field30: 0,
                    }

                    if ($scope.CompanyProfile.DefaultWarehouseId > 0) {
                        SalesQuotationDetails.WarehouseId = $scope.CompanyProfile.DefaultWarehouseId;
                    }



                    if (temp != 100) {
                        $scope.ISalesInvoice.SalesQuotationDetails.push(SalesQuotationDetails);
                    } else {

                        var index = $scope.ISalesInvoice.SalesQuotationDetails.indexOf($scope.ClickedRow);
                        $scope.ISalesInvoice.SalesQuotationDetails.splice(index + 1, 0, SalesQuotationDetails);
                    }
                }


            }

            $scope.expand = function () {
                $scope.expandView = !$scope.expandView;
            }

            $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];
                if ($scope.TableReorder != null && $scope.TableReorder != "") {
                    if ($scope.TableReorder.ColumnArray != null && $scope.TableReorder.ColumnArray != '' && $scope.TableReorder.ColumnArray != undefined) {
                        var arr = $scope.TableReorder.ColumnArray;
                        $scope.tableReorderColumnArray = JSON.parse(arr);
                        $scope.RearrangeReqired = true;
                        $scope.rearrangeTableCells($scope.tableReorderColumnArray);
                    }
                }

                if($scope.ColumnWidth != null){
                            document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                                let key = cell.getAttribute('data-key');
                                if ($scope.ColumnWidth[key] !== undefined) {
                                    cell.style.width = $scope.ColumnWidth[key] + "px";
                                }
                            });
                        }
                         else {
                    toastr.info("Table Width Adjustment Empty, Applying Default Width")
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        cell.style.width = "100px";
                    });
                }

            };


            $scope.init = function () {

                $scope.rowId = 0;
                $scope.expandView = false;
                $scope.IsAllowChangeQty = false;
                $scope.IsAllowAddProduct = false;

                $scope.IsVoucherLinkCost = false;
                $scope.VCCostcenterId = "";
                $scope.mvl = {
                    SelectAllMVlinks: false
                };
                $scope.ViewVal = 0;
                $scope.ViewValLink = 0;
                $scope.Load = false;
                $scope.ErrorText = "";
                $scope.print = {
                    IsPrint: false,
                }

                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day);

                $scope.ISalesInvoice = {
                    Id: 0,
                    Date: new Date(),
                      IsForceSave : false,
                    SalesQuotationDetails: [],
                    VoucherNumber: "",
                    Remarks: "",
                    IntroLetterDescription: "",
                    EndLetterDescription: "",
                    NetTotal: 0,
                    TotalTax: 0,
                    GrandTotal: 0,
                    EnquiryNo: "",
                    DeliveryPeriod: "",
                    PaymentTerms: "",
                    DeliveryBasis: "",
                    WarrantyPeriod: "",
                    CustomerId: "",
                    CustomerName: "",
                    IsMail: false,
                    BaseCurrencyId: "",
                    TotalExtraCharges: 0,
                    TotalOtherCharges: 0,
                    CashAmount: 0,
                    CreditAmount: 0,
                    CardAmount: 0,
                    PaymentType: "CREDIT",
                    LinkEnquiryNo: "",
                    LinkQuotationNo: "",
                    LinkOrderNo: "",
                    LinkInvoiceNo: "",
                    LinkPackingNo: "",
                    LinkDeliveryNo: "",
                    LinkReturnNo: "",
                    LinkProInvoiceNo: "",
                }


                $scope.CompanyProfile = {};
                $scope.TableReorder = {};

                if ($stateParams.VoucherId > 0) {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.VoucherSettingsbyType("Sales Quotation").then(function (response) {
                        if (response.data) {

                            $scope.CompanyProfile = response.data.CompanyProfile;
                            $scope.CostCenters = response.data.CostCenterSettings;

                            $scope.VoucherSet = response.data.voucherAccount;

                            if ($scope.VoucherSet == null || $scope.VoucherSet == "") {
                                $scope.VoucherSet = {
                                    AllowZeroCost: false
                                };
                            }

                            $scope.VDesign = response.data.VoucherDesign;
                            $scope.TableReorder = response.data.TableReorder;
                            setTimeout(function () {
                                $scope.ReArrangeTable();
                            }, 2000);
                            $scope.loadVoucher($stateParams.VoucherId);

                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    })

                } else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.VoucherSettings = {};

                    MainService.VoucherSettingsbyType("Sales Quotation").then(function (response) {
                        if (response.data) {
                            $scope.VoucherSettings = response.data;

                            $scope.CompanyProfile = response.data.CompanyProfile;
                            $scope.ISalesInvoice.BaseCurrencyId = $scope.CompanyProfile.BaseCurrencyId;

                            $scope.VDesign = response.data.VoucherDesign;
                            $scope.TableReorder = response.data.TableReorder;

                            $scope.ISalesInvoice.IntroLetterDescription = $scope.VDesign.IntroLetterDescription;
                            $scope.ISalesInvoice.EndLetterDescription = $scope.VDesign.EndLetterDescription;


                            $scope.VoucherSet = response.data.voucherAccount;

                            $scope.ISalesInvoice.PaymentType = $scope.VoucherSet.PaymentType;
                            if ($scope.ISalesInvoice.PaymentType == "" || $scope.ISalesInvoice.PaymentType == null) {
                                $scope.ISalesInvoice.PaymentType = "CREDIT";
                            }

                            for (var i = 0; i < 5; i++) {
                                $scope.InsertRow(1);
                            }


                            if ($scope.VoucherSet == null || $scope.VoucherSet == "") {
                                $scope.VoucherSet = {
                                    AllowZeroCost: false
                                };
                            }
                            if ($scope.VoucherSet.DefauldProductId > 0) {
                                $scope.setDefaultProduct();
                            }

                            if ($scope.VoucherSet.IsDefaultCustomer) {
                                $scope.setDefaultAccount();
                            }


                            $scope.CostCenters = response.data.CostCenterSettings;

                            MainService.GetNextSalesQuotationNo().then(function (response2) {
                                $scope.traceNo = response2.data;
                                $scope.ISalesInvoice.VoucherNumber = response2.data;

                                angular.forEach($scope.CostCenters, function (cst) {
                                    if (cst.IsAuto) {
                                        var temp = {
                                            Id: 0,
                                            Name: $scope.ISalesInvoice.VoucherNumber,
                                            Code: "",
                                        }
                                        cst.CostCenters.push(temp);
                                        cst.SelectedCostCenterId = 0;
                                    }
                                })
                            });

                            if ($stateParams.LinkVoucherId > 0) {

                                $.LoadingOverlay("show", {
                                    image: "images/load.gif",
                                });

                                MainService.getCommonVocherLinkingId($stateParams.LinkVoucherId, $stateParams.VoucherType, "Sales Quotation").then(function (resLink) {
                                    $.LoadingOverlay("hide");
                                    if (resLink.data.IsNotApproved == true) {
                                        toastr.error("Voucher Not Approved. Please Try After.");
                                    } else if (resLink.data.CommonVoucherDetails.length > 0) {
                                        $scope.showUpdatePreview(resLink.data);
                                        $scope.IsAllowChangeQty = resLink.IsAllowChangeQty;
                                        $scope.IsAllowAddProduct = resLink.IsAllowAddProduct;
                                    } else {
                                        toastr.error("No balance quantity available for linking");
                                    }
                                }, function (err) {
                                    toastr.error("Network Error While Linking");
                                    $.LoadingOverlay("hide");
                                })


                            } else {
                                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                                    e.CostCenters = angular.copy($scope.CostCenters);
                                })
                            }

                            setTimeout(function () {
                                $scope.ReArrangeTable();
                            }, 2000);

                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("NetworkError");
                        $.LoadingOverlay("hide");
                    })


                }

            }
            $scope.init();

            $scope.ChangeView = function (id) {
                $scope.ViewVal = id;
            }


            $scope.CustomerAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Head";
                        o.data.VoucherName = "Sales Quotation";
                        MainService.LoadCustomerAccountsSPInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.CustomerAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.ISalesInvoice.Customer = {};
                    $scope.ISalesInvoice.Customer = data;
                    $scope.ISalesInvoice.CustomerId = data.Id;
                    $scope.ISalesInvoice.DueDays = data.CreditDays;
                    if (data.EmployeeId > 0) {
                        $scope.ISalesInvoice.EmployeeId = data.EmployeeId;
                    }
                    $scope.$apply();
                    $scope.ApplyVatCostCenters(data);
                    $scope.FilterCustomerCostCenters();
                    $scope.getCustomerContacts();
                },
                minLength: 2,
                dataSource: $scope.CustomerAutocompleteDataSource
            };


            $scope.CustomerMobAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "MobileNo",
                dataTextField: "MobileNo",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.ISalesInvoice.Customer = {};
                    $scope.ISalesInvoice.Customer = data;
                    $scope.ISalesInvoice.CustomerId = data.Id;
                    $scope.ISalesInvoice.DueDays = data.CreditDays;
                    if (data.EmployeeId > 0) {
                        $scope.ISalesInvoice.EmployeeId = data.EmployeeId;
                    }
                    $scope.$apply();
                    $scope.ApplyVatCostCenters(data);
                    $scope.FilterCustomerCostCenters();
                    $scope.getCustomerContacts();
                },
                minLength: 2,
                dataSource: $scope.CustomerAutocompleteDataSource
            };

            $scope.CustomerCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "AccountCode",
                dataTextField: "AccountCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.ISalesInvoice.Customer = {};
                    $scope.ISalesInvoice.Customer = data;
                    $scope.ISalesInvoice.CustomerId = data.Id;
                    $scope.ISalesInvoice.DueDays = data.CreditDays;
                    if (data.EmployeeId > 0) {
                        $scope.ISalesInvoice.EmployeeId = data.EmployeeId;
                    }
                    $scope.$apply();
                    $scope.ApplyVatCostCenters(data);
                    $scope.FilterCustomerCostCenters();
                    $scope.getCustomerContacts();
                },
                minLength: 2,
                dataSource: $scope.CustomerAutocompleteDataSource
            };

            $scope.getCustomerContacts = function () {

                MainService.GetAccountContactList($scope.ISalesInvoice.CustomerId).then(function (response) {
                    $scope.AccountContactList = response.data;
                }, function (err) {
                    toastr.error("Network Error");
                })

                MainService.GetAccountAddressList($scope.ISalesInvoice.CustomerId).then(function (response) {
                    $scope.AccountAddressList = response.data;
                }, function (err) {
                    toastr.error("Network Error");
                })
            }

            $scope.FilterCustomerCostCenters = function () {

                MainService.AccountCostCentersList($scope.ISalesInvoice.CustomerId)
                    .then(function (response) {

                        angular.forEach($scope.CostCenters, function (e) {
                            angular.forEach(response.data, function (a) {

                                if (e.CostCenterId == a.CostCenterId) {
                                    if (a.Childrens.length > 0) {
                                        e.CostCenters = a.Childrens;
                                    }
                                }

                            })
                        })

                        $scope.LoadFromChartHead();

                    }, function (err) {
                        toastr.error("NetworkError");
                    })


            }

            /////////////////////////////////Product//////////////

           $scope.LoadProductMultiSelect = function () {

                $scope.productsMultiSearchDataSource = {
                    type: "odata",
                    serverFiltering: true,
                    serverPaging: true,
                    pageSize: 20,
                    transport: {
                        read: function (o) {
                            if (o.data.filter != undefined) {
                                if (o.data.filter.filters.length == 0) { } else {
                                    o.data.Sort = [
                                        {
                                            Dir: "desc",
                                            Field: "Balance"
                                        }
                                    ];
                                    MainService.productInAutoComplete(o.data).then(function (response) {

                                        if ($scope.VoucherSet.DefauldUnitId > 0) {
                                            angular.forEach(response.data.Data, function (e) {
                                                e.UnitId = $scope.VoucherSet.DefauldUnitId;
                                                e.Unit = $scope.VoucherSet.DefauldUnit;
                                            })
                                        }

                                        var temp = {
                                            d: {
                                                "results": response.data.Data,
                                                "__count": response.data.Total
                                            }
                                        }
                                        o.success(temp);
                                    }, function (err) {
                                        o.success({
                                            Data: []
                                        });
                                        toastr.error($scope.NetworkErrorLan);
                                    });
                                }
                            } else {
                                var temp = {
                                    d: {
                                        "results": [],
                                        "__count": 0
                                    }
                                }
                                o.success(temp);
                            }
                        }
                    }
                };


                $scope.ProductMultiSearchOptions = {
                    placeholder: "",
                    dataTextField: "Name",
                    dataValueField: "Name",
                    filter: "contains",
                    autoBind: false,
                    minLength: 3,
                    enforceMinLength: true,
                    dropDownWidth: 700,
                    clearButton: false,
                    height: 300,
                    dataSource: $scope.productsMultiSearchDataSource,
                    columns: $scope.ProductColumns,

                };

                $scope.ProductCodeMultiSearchOptions = {
                    placeholder: "",
                    dataTextField: "ProductCode",
                    dataValueField: "ProductCode",
                    filter: "contains",
                    autoBind: false,
                    minLength: 3,
                    enforceMinLength: true,
                    dropDownWidth: 700,
                    height: 300,
                    dataSource: $scope.productsMultiSearchDataSource,
                    columns: $scope.ProductColumns,

                };
            }

            $scope.InitProductMultiSelect = function () {
                $scope.ProductColumns = [
                    {
                        field: "Name",
                        title: "Name",
                        width: "250px"
                    },
                    {
                        field: "ProductCode",
                        title: "Code",
                        width: "100px"
                    },
                    {
                        field: "CategoryName",
                        title: "Category",
                        width: "100px"
                    },
                    {
                        field: "BrandName",
                        title: "Brand",
                        width: "100px"
                    },
                    {
                        field: "CountryName",
                        title: "Country",
                        width: "100px"
                    },
                    {
                        field: "HSCode",
                        title: "HS_Code",
                        width: "100px"
                    },
                    {
                        field: "Balance",
                        title: "Balance",
                        width: "100px"
                    },
                    {
                        field: "Weight",
                        title: "Weight",
                        width: "100px"
                    },
                    {
                        field: "Field1",
                        title: "Field1",
                        width: "100px"
                    },
                    {
                        field: "Description",
                        title: "Description",
                        width: "150px"
                    },

                ];


                MainService.GetProductDesign().then(function (response) {
                    if (response.data != null && response.data != "") {
                        if (response.data.ProductViewOrder != null) {
                            if (response.data.ProductViewOrder.length > 0) {
                                $scope.ProductColumns = JSON.parse(response.data.ProductViewOrder);
                            }
                        }
                    }
                    $scope.LoadProductMultiSelect();
                }, function (err) {
                    $scope.LoadProductMultiSelect();
                });
            }
            $scope.InitProductMultiSelect();

            $scope.applyFocus = function (data) {
                $scope.SelectedCE = data;
            }

            $scope.click2 = function (data, product) {

                var comboBox = $("#kendoProduct" + data.rowId).data("kendoMultiColumnComboBox");
                var product = comboBox.dataItem(); // Get selected item directly
                console.log('onChange selected:', product); // Optional: Log for verification

                if (product != undefined) {
                    data.Product = {};
                    data.Product.Name = product.Name;
                    data.Remarks = product.Description;
                    data.Product.ProductCode = product.ProductCode;
                    data.Product.Balance = product.Balance;
                    data.Product.AveragePrice = product.AveragePrice;
                    data.ProductId = product.Id;
                    data.UnitId = product.UnitId;
                    data.UnitPrice = product.SellPrice;
                    data.CountryId = product.CountryId;
                    data.BrandId = product.BrandId;
                    data.VATId = product.VATId;
                    data.UnitPrice = product.SellPrice;
                    data.Cost = product.AveragePrice;
                    data.COGS = product.AveragePrice;
                    data.NetWeight = product.Weight;
                    data.GrossWeight = product.GrossWeight;
                    data.VatType = product.VatType;
                    data.Field9 = product.Field9;

                    $scope.click($scope.ISalesInvoice.SalesQuotationDetails[data.rowId], 0);
                    $scope.LoadFromChart(3);
                }
            }

            $scope.click3 = function (data, product) {

                var comboBox = $("#kendoProductCode" + data.rowId).data("kendoMultiColumnComboBox");
                var product = comboBox.dataItem(); // Get selected item directly
                console.log('onChange selected:', product); // Optional: Log for verification

                if (product != undefined) {
                    data.Product = {};
                    data.Product.Name = product.Name;
                    data.Remarks = product.Description;
                    data.Product.ProductCode = product.ProductCode;
                    data.Product.Balance = product.Balance;
                    data.Product.AveragePrice = product.AveragePrice;
                    data.ProductId = product.Id;
                    data.UnitId = product.UnitId;
                    data.UnitPrice = product.SellPrice;
                    data.CountryId = product.CountryId;
                    data.BrandId = product.BrandId;
                    data.VATId = product.VATId;
                    data.UnitPrice = product.SellPrice;
                    data.Cost = product.AveragePrice;
                    data.COGS = product.AveragePrice;
                    data.NetWeight = product.Weight;
                    data.GrossWeight = product.GrossWeight;
                    data.VatType = product.VatType;
                    data.Field9 = product.Field9;

                    $scope.click($scope.ISalesInvoice.SalesQuotationDetails[data.rowId], 0);
                    $scope.LoadFromChart(3);
                }
            }

            $scope.unitclick = function (data, temp) {
                $scope.SelectedCE = data;
                $scope.ClickedRow = data;
                $scope.LoadFromChart();
            }


            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;

                if (temp == 44) {
                    $scope.loadWarehouse2(data);
                }

                if ($scope.VoucherSet.IsLoadProductUnitOnly && $scope.SelectedCE.ProductId > 0) {
                    MainService.GetProductUnitsInDropdown($scope.SelectedCE.ProductId).then(function (response) {
                        if (response.data.length > 0) {
                            data.Units = response.data;
                        } else {
                            data.Units = $scope.Units;
                        }
                    })
                } else {
                    data.Units = $scope.Units;
                }

                if ($scope.SelectedCE.Field1 != undefined && $scope.SelectedCE.Field2 != undefined) {
                    if ($scope.VoucherSet.IsQtyFormulaField12 && $scope.SelectedCE.Field1.length > 0 && $scope.SelectedCE.Field2.length > 0) {
                        var f1 = parseFloat($scope.SelectedCE.Field1);
                        var f2 = parseFloat($scope.SelectedCE.Field2);
                        $scope.SelectedCE.Quantity = f1 * f2;
                        $scope.SelectedCE.Field10 = f2 * $scope.SelectedCE.UnitPrice;
                    }
                }


                if ($scope.VDesign.DField20 == "Fabrication") {

                    var f1 = 0;
                    var f2 = 0;
                    var f3 = 0;
                    var f4 = 0;

                    if ($scope.SelectedCE.Field1 != null && $scope.SelectedCE.Field1 != undefined && $scope.SelectedCE.Field1 != "") {
                        f1 = parseFloat($scope.SelectedCE.Field1);
                    }
                    if ($scope.SelectedCE.Field2 != null && $scope.SelectedCE.Field2 != undefined && $scope.SelectedCE.Field2 != "") {
                        f2 = parseFloat($scope.SelectedCE.Field2);
                    }

                    if (f1 > 0 && f2 > 0) {
                        f3 = f1 * f2 / 1000000;
                        f3 = f3.toFixed(3);
                        $scope.SelectedCE.Field3 = f3;
                    }


                    if ($scope.SelectedCE.Field4 != null && $scope.SelectedCE.Field4 != undefined && $scope.SelectedCE.Field4 != "") {
                        f4 = parseFloat($scope.SelectedCE.Field4);
                    }


                    if (f3 > 0 && f4 > 0) {
                        $scope.SelectedCE.Quantity = f3 * f4;
                        $scope.SelectedCE.Quantity = parseFloat($scope.SelectedCE.Quantity.toFixed(3));
                    }

                }

                if ($scope.VDesign.DField20 == "Stones") {

                    var materialRate = 0;
                    if ($scope.SelectedCE.Field1 && $scope.SelectedCE.Field1 != undefined && $scope.SelectedCE.Field1 != "") {
                        materialRate = parseFloat($scope.SelectedCE.Field1);
                    }

                    var transportRate = 0;
                    if ($scope.SelectedCE.Field2 && $scope.SelectedCE.Field2 != undefined && $scope.SelectedCE.Field2 != "") {
                        transportRate = parseFloat($scope.SelectedCE.Field2);
                    }

                    var tollRate = 0;
                    if ($scope.SelectedCE.Field3 && $scope.SelectedCE.Field3 != undefined && $scope.SelectedCE.Field3 != "") {
                        tollRate = parseFloat($scope.SelectedCE.Field3);
                    }

                    $scope.SelectedCE.UnitPrice = materialRate + transportRate + tollRate;
                    $scope.SelectedCE.Field6 = $scope.SelectedCE.Quantity * materialRate;
                    $scope.SelectedCE.Field7 = $scope.SelectedCE.Quantity * transportRate;
                    $scope.SelectedCE.Field8 = $scope.SelectedCE.Quantity * tollRate;

                }

                if ($scope.VDesign.DField20 == "PPC SEA") {

                    $scope.SelectedCE.Field25 = ($scope.SelectedCE.Field22 * $scope.SelectedCE.Field23 * $scope.SelectedCE.Field24) / 5000;
                    $scope.SelectedCE.Field26 = $scope.SelectedCE.Field25 * $scope.SelectedCE.UnitPrice;

                    var highest = Math.max($scope.SelectedCE.Field21, $scope.SelectedCE.Field25);
                    $scope.SelectedCE.Quantity = $scope.SelectedCE.Field24;

                }

                if ($scope.VDesign.DField20 == "PPC AIR") {

                    $scope.SelectedCE.Field25 = ($scope.SelectedCE.Field22 * $scope.SelectedCE.Field23 * $scope.SelectedCE.Field24) / 5000;
                    $scope.SelectedCE.Field26 = $scope.SelectedCE.Field25 * $scope.SelectedCE.UnitPrice;

                    $scope.SelectedCE.Field27 = ($scope.SelectedCE.Field22 * $scope.SelectedCE.Field23 * $scope.SelectedCE.Field24) / 6000;
                    $scope.SelectedCE.Field28 = $scope.SelectedCE.Field27 * $scope.SelectedCE.UnitPrice;

                    var highest = Math.max($scope.SelectedCE.Field21, $scope.SelectedCE.Field25, $scope.SelectedCE.Field27);
                    $scope.SelectedCE.Quantity = highest;
                }

 if ($scope.VoucherSet.IsQuantityFormula) {
                if ($scope.VoucherSet.QuantityFormulaExe != "" && $scope.VoucherSet.QuantityFormulaExe != null) {
                    $scope.$eval($scope.VoucherSet.QuantityFormulaExe, { data: data });
                }
            }

            if ($scope.VoucherSet.IsUnitPriceFormula) {
                if ($scope.VoucherSet.UnitPriceFormulaExe != "" && $scope.VoucherSet.UnitPriceFormulaExe != null) {
                    $scope.$eval($scope.VoucherSet.UnitPriceFormulaExe, { data: data });
                }
            }

                if ($scope.VoucherSet.IsManualCost) {
                    $scope.SelectedCE.COGS = $scope.SelectedCE.Cost;
                    $scope.SelectedCE.TCost = $scope.SelectedCE.Quantity * $scope.SelectedCE.Cost;
                    $scope.SelectedCE.TCost = $scope.roundOffValue(data.TCost);
                    $scope.clickCalc(data, temp);
                } else {

                    if (data.ProductId > 0) {
                        var pdt = {
                            ProductId: data.ProductId,
                            UnitId: data.UnitId,
                            DateString: $scope.extractDate($scope.ISalesInvoice.Date),
                            Quantity: data.Quantity
                        }

                        if ($scope.CompanyProfile.CostValuationMethod == "FIFO" || $scope.CompanyProfile.CostValuationMethod == "LIFO") {

                            MainService.GetPurchaseFIFOCost(pdt).then(function (response) {
                                $scope.SelectedCE.Cost = response.data.TotalCost / data.Quantity;
                                $scope.SelectedCE.Cost = $scope.roundOffValue($scope.SelectedCE.Cost);
                                $scope.SelectedCE.COGS = $scope.SelectedCE.Cost;
                                $scope.SelectedCE.TCost = response.data.TotalCost;
                                $scope.SelectedCE.TCost = $scope.roundOffValue($scope.SelectedCE.TCost);
                                if ($scope.VoucherSet.IsUseCostAsUnitPrice) {
                                    $scope.SelectedCE.UnitPrice = $scope.SelectedCE.Cost;
                                }
                                $scope.clickCalc(data, temp);
                            })

                        } else {
                            MainService.GetProductCost(pdt).then(function (response) {
                                $scope.SelectedCE.Cost = response.data;
                                $scope.SelectedCE.COGS = response.data;
                                $scope.SelectedCE.TCost = $scope.SelectedCE.Quantity * $scope.SelectedCE.Cost;
                                $scope.SelectedCE.TCost = $scope.roundOffValue(data.TCost);
                                if ($scope.VoucherSet.IsUseCostAsUnitPrice) {
                                    $scope.SelectedCE.UnitPrice = response.data;
                                }
                                $scope.clickCalc(data, temp);
                            })
                        }


                    }

                }

                 if (data.ProductId > 0) {
                    if(data.WarehouseId > 0){
                            MainService.GetWarehouseStockBalance(data.ProductId, data.WarehouseId).then(function (response) {
                                if(response.data){
                                    $scope.SelectedCE.WStock = response.data;
                                }
                            })
                        }
                }

            }

            $scope.clickCalc = function (data, temp) {

                $scope.SelectedCE = data;
                $scope.SelectedCE.TotalNetWeight = $scope.SelectedCE.Quantity * $scope.SelectedCE.NetWeight;
                $scope.SelectedCE.TotalGrossWeight = $scope.SelectedCE.Quantity * $scope.SelectedCE.GrossWeight;

                if ($scope.VDesign.IsShippingFormula) {
                    var v1 = parseFloat($scope.SelectedCE.Field1);
                    var v2 = parseFloat($scope.SelectedCE.Field2);
                    var v3 = parseFloat($scope.SelectedCE.Field3);
                    var vt = (v1 * v2 * v3 * $scope.SelectedCE.Quantity) / 1.62;
                    vt = $scope.roundOffValue(vt);
                    $scope.SelectedCE.Field6 = vt.toString();
                }

                $scope.SelectedCE.Total = $scope.SelectedCE.Quantity * $scope.SelectedCE.UnitPrice;
                $scope.SelectedCE.Total = $scope.roundOffValue($scope.SelectedCE.Total);

                $scope.SelectedCE.taxval = 0;
                angular.forEach($scope.VATs, function (e) {
                    if (e.Id == $scope.SelectedCE.VATId) {
                        $scope.SelectedCE.taxval = e.Value;
                    }
                });

                if ($scope.VDesign.UnlockDiscount == false) {
                    if ($scope.SelectedCE.DiscountType == "Value") {
                        $scope.SelectedCE.Discount = $scope.SelectedCE.DiscountValue;
                    } else {
                        var disc = $scope.SelectedCE.Total * ($scope.SelectedCE.DiscountValue / 100);
                        $scope.SelectedCE.Discount = $scope.roundOffValue(disc);
                    }
                }


                if ($scope.SelectedCE.VatType != "Exclusive") {
                    $scope.SelectedCE.TaxValue = (($scope.SelectedCE.Total - $scope.SelectedCE.Discount + $scope.SelectedCE.OtherCharges) * $scope.SelectedCE.taxval) / (100 + $scope.SelectedCE.taxval);
                    $scope.SelectedCE.TaxValue = $scope.roundOffValue($scope.SelectedCE.TaxValue);
                    $scope.SelectedCE.TaxableAmount = $scope.SelectedCE.Total - $scope.SelectedCE.Discount + $scope.SelectedCE.OtherCharges;
                    $scope.SelectedCE.TaxableAmount = $scope.SelectedCE.TaxableAmount - $scope.SelectedCE.TaxValue;
                    if($scope.VoucherSet.IsTaxableForumala){
                        if($scope.VoucherSet.TaxableForumalaExe != "" && $scope.VoucherSet.TaxableForumalaExe != null){
                            $scope.$eval($scope.VoucherSet.TaxableForumalaExe, { data: data });
                        }
                    }
                    $scope.SelectedCE.TaxableAmount = $scope.roundOffValue($scope.SelectedCE.TaxableAmount);
                } else {
                    $scope.SelectedCE.TaxableAmount = $scope.SelectedCE.Total - $scope.SelectedCE.Discount + $scope.SelectedCE.OtherCharges;
                    if($scope.VoucherSet.IsTaxableForumala){
                        if($scope.VoucherSet.TaxableForumalaExe != "" && $scope.VoucherSet.TaxableForumalaExe != null){
                            $scope.$eval($scope.VoucherSet.TaxableForumalaExe, { data: data });
                        }
                    }
                    $scope.SelectedCE.TaxableAmount = $scope.roundOffValue($scope.SelectedCE.TaxableAmount);
                    $scope.SelectedCE.TaxValue = $scope.SelectedCE.TaxableAmount * ($scope.SelectedCE.taxval / 100);
                    $scope.SelectedCE.TaxValue = $scope.roundOffValue($scope.SelectedCE.TaxValue);
                }

                if ($scope.VoucherSet.IsReverseVAT) {
                    var totalLevi = 0;
                    if ($scope.SelectedCE.Vat1Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat1;
                    }
                    if ($scope.SelectedCE.Vat2Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat2;
                    }
                    if ($scope.SelectedCE.Vat3Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat3;
                    }
                    if ($scope.SelectedCE.Vat4Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat4;
                    }
                    if ($scope.SelectedCE.Vat5Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat5;
                    }


                    if (totalLevi > 0) {

                        var leviesFraction = (totalLevi / (totalLevi + 100)) * $scope.SelectedCE.TaxableAmount;
                        $scope.SelectedCE.AssessableValue = $scope.SelectedCE.TaxableAmount - leviesFraction;
                        $scope.SelectedCE.AssessableValue = $scope.roundOffValue($scope.SelectedCE.AssessableValue);

                        if ($scope.SelectedCE.Vat1Per > 0) {

                            $scope.SelectedCE.Vat1Value = $scope.SelectedCE.AssessableValue * ($scope.SelectedCE.Vat1Per / 100);
                            $scope.SelectedCE.Vat1Value = $scope.roundOffValue($scope.SelectedCE.Vat1Value);

                            //                            $scope.SelectedCE.Vat1Value = ($scope.SelectedCE.AssessableValue * $scope.SelectedCE.Vat1Per) / (100 + $scope.SelectedCE.Vat1Per);
                            //                            $scope.SelectedCE.Vat1Value = $scope.roundOffValue($scope.SelectedCE.Vat1Value * 100) / 100;
                        }

                        if ($scope.SelectedCE.Vat2Per > 0) {

                            $scope.SelectedCE.Vat2Value = $scope.SelectedCE.AssessableValue * ($scope.SelectedCE.Vat2Per / 100);
                            $scope.SelectedCE.Vat2Value = $scope.roundOffValue($scope.SelectedCE.Vat2Value);

                            //                            $scope.SelectedCE.Vat2Value = ($scope.SelectedCE.AssessableValue * $scope.SelectedCE.Vat2Per) / (100 + $scope.SelectedCE.Vat2Per);
                            //                            $scope.SelectedCE.Vat2Value = $scope.roundOffValue($scope.SelectedCE.Vat2Value * 100) / 100;
                        }

                        if ($scope.SelectedCE.Vat3Per > 0) {

                            $scope.SelectedCE.Vat3Value = $scope.SelectedCE.AssessableValue * ($scope.SelectedCE.Vat3Per / 100);
                            $scope.SelectedCE.Vat3Value = $scope.roundOffValue($scope.SelectedCE.Vat3Value);

                            //                            $scope.SelectedCE.Vat3Value = ($scope.SelectedCE.AssessableValue * $scope.SelectedCE.Vat3Per) / (100 + $scope.SelectedCE.Vat3Per);
                            //                            $scope.SelectedCE.Vat3Value = $scope.roundOffValue($scope.SelectedCE.Vat3Value * 100) / 100;
                        }

                        if ($scope.SelectedCE.Vat4Per > 0) {

                            $scope.SelectedCE.Vat4Value = $scope.SelectedCE.AssessableValue * ($scope.SelectedCE.Vat4Per / 100);
                            $scope.SelectedCE.Vat4Value = $scope.roundOffValue($scope.SelectedCE.Vat4Value);

                            //                            $scope.SelectedCE.Vat4Value = ($scope.SelectedCE.AssessableValue * $scope.SelectedCE.Vat4Per) / (100 + $scope.SelectedCE.Vat4Per);
                            //                            $scope.SelectedCE.Vat4Value = $scope.roundOffValue($scope.SelectedCE.Vat4Value * 100) / 100;
                        }

                        if ($scope.SelectedCE.Vat5Per > 0) {

                            $scope.SelectedCE.Vat5Value = $scope.SelectedCE.AssessableValue * ($scope.SelectedCE.Vat5Per / 100);
                            $scope.SelectedCE.Vat5Value = $scope.roundOffValue($scope.SelectedCE.Vat5Value);

                            //                            $scope.SelectedCE.Vat5Value = ($scope.SelectedCE.AssessableValue * $scope.SelectedCE.Vat5Per) / (100 + $scope.SelectedCE.Vat5Per);
                            //                            $scope.SelectedCE.Vat5Value = $scope.roundOffValue($scope.SelectedCE.Vat5Value * 100) / 100;
                        }


                    }

                }



                if (temp != 50) {
                    $scope.SelectedCE.RoundOfVat = $scope.SelectedCE.TaxValue;
                }

                $scope.SelectedCE.InventoryValue = $scope.SelectedCE.TaxableAmount + $scope.SelectedCE.RoundOfVat + $scope.SelectedCE.ExtraCharges;
                if($scope.VDesign.IsGrandTotalFormula){
                    if($scope.VDesign.GranTotalForumalaExe != "" && $scope.VDesign.GranTotalForumalaExe != null){
                        $scope.$eval($scope.VoucherSet.GranTotalForumalaExe, { data: data });
                    }
                }
                $scope.SelectedCE.InventoryValue = $scope.roundOffValue($scope.SelectedCE.InventoryValue);


                $scope.CalculateTotals();

                var a = $scope.ISalesInvoice.SalesQuotationDetails.indexOf(data);

                if (($scope.ISalesInvoice.SalesQuotationDetails.length - 1) == a) {
                    $scope.ContextInsertRow(1);
                }

            }

            $scope.dateChange = function () {
                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                    $scope.click(e, 1);
                })
            }


            $scope.CalculateTotals = function () {


                $scope.ISalesInvoice.TotalQuantity = 0;
                $scope.ISalesInvoice.TotalDiscount = 0;
                $scope.ISalesInvoice.GrossTotal = 0;
                $scope.ISalesInvoice.NetTotal = 0;
                $scope.ISalesInvoice.TotalTax = 0;
                $scope.ISalesInvoice.GrandTotal = 0;
                $scope.ISalesInvoice.TotalExtraCharges = 0;
                $scope.ISalesInvoice.TotalOtherCharges = 0;


                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {

                    if (e.ProductId > 0) {

                        $scope.ISalesInvoice.TotalQuantity = $scope.ISalesInvoice.TotalQuantity + e.Quantity;

                        $scope.ISalesInvoice.TotalDiscount = $scope.ISalesInvoice.TotalDiscount + e.Discount;
                        $scope.ISalesInvoice.TotalDiscount = $scope.roundOffValue($scope.ISalesInvoice.TotalDiscount);

                        $scope.ISalesInvoice.GrossTotal = $scope.ISalesInvoice.GrossTotal + e.Total;
                        $scope.ISalesInvoice.GrossTotal = $scope.roundOffValue($scope.ISalesInvoice.GrossTotal);

                        $scope.ISalesInvoice.NetTotal = $scope.ISalesInvoice.NetTotal + e.TaxableAmount;
                        $scope.ISalesInvoice.NetTotal = $scope.roundOffValue($scope.ISalesInvoice.NetTotal);

                        $scope.ISalesInvoice.TotalTax = $scope.ISalesInvoice.TotalTax + e.RoundOfVat;
                        $scope.ISalesInvoice.TotalTax = $scope.roundOffValue($scope.ISalesInvoice.TotalTax);

                        $scope.ISalesInvoice.GrandTotal = $scope.ISalesInvoice.GrandTotal + e.InventoryValue;
                        $scope.ISalesInvoice.GrandTotal = $scope.roundOffValue($scope.ISalesInvoice.GrandTotal);

                        $scope.ISalesInvoice.TotalExtraCharges = $scope.ISalesInvoice.TotalExtraCharges + e.ExtraCharges;
                        $scope.ISalesInvoice.TotalExtraCharges = $scope.roundOffValue($scope.ISalesInvoice.TotalExtraCharges);

                        $scope.ISalesInvoice.TotalOtherCharges = $scope.ISalesInvoice.TotalOtherCharges + e.OtherCharges;
                        $scope.ISalesInvoice.TotalOtherCharges = $scope.roundOffValue($scope.ISalesInvoice.TotalOtherCharges);

                    }

                });

                if ($scope.ISalesInvoice.AddDiscountPer > 0 && $scope.VDesign.IsUnlockAdditionalDiscount == false) {

                    var disc = $scope.ISalesInvoice.GrandTotal * ($scope.ISalesInvoice.AddDiscountPer / 100);
                    $scope.ISalesInvoice.AddDiscount = $scope.roundOffValue(disc);
                }

                if ($scope.VDesign.IsUnlockAdditionalDiscount) {

                    $scope.ISalesInvoice.AddDiscountPer = ($scope.ISalesInvoice.AddDiscount / $scope.ISalesInvoice.GrandTotal) * 100;
                    $scope.ISalesInvoice.AddDiscountPer = $scope.roundOffValue($scope.ISalesInvoice.AddDiscountPer);
                }

                if ($scope.ISalesInvoice.AddDiscount > 0) {
                    $scope.ISalesInvoice.TotalDiscount = $scope.ISalesInvoice.TotalDiscount + $scope.ISalesInvoice.AddDiscount;
                    $scope.ISalesInvoice.TotalDiscount = $scope.roundOffValue($scope.ISalesInvoice.TotalDiscount);

                    $scope.ISalesInvoice.GrandTotal = $scope.ISalesInvoice.GrandTotal - $scope.ISalesInvoice.AddDiscount;
                    $scope.ISalesInvoice.GrandTotal = $scope.roundOffValue($scope.ISalesInvoice.GrandTotal);
                }

                $scope.calculateAdvance();
                $scope.updateCashCredit();

            }


            $scope.calculateAdvance = function () {
                if ($scope.VDesign.IsAdvancePer && $scope.ISalesInvoice.AdvancePer > 0) {
                    $scope.ISalesInvoice.Advance = ($scope.ISalesInvoice.GrandTotal - $scope.ISalesInvoice.TotalTax) * ($scope.ISalesInvoice.AdvancePer / 100);
                    $scope.ISalesInvoice.Advance = $scope.roundOffValue($scope.ISalesInvoice.Advance);

                    $scope.ISalesInvoice.AdvanceVAT = $scope.ISalesInvoice.TotalTax * ($scope.ISalesInvoice.AdvancePer / 100);
                    $scope.ISalesInvoice.AdvanceVAT = $scope.roundOffValue($scope.ISalesInvoice.AdvanceVAT);
                }
            }

            $scope.openMultiProductPrice = function (row) {
                if (row.ProductId > 0) {

                    $scope.MultiProducts = {};
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.GetProductMultiPrice(row.ProductId).then(function (response) {
                        if (response.data) {
                            $scope.MultiProducts = response.data;
                            $('#multiPriceModal').modal('show');
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("NetworkError");
                        $scope.Load = false;
                    });
                }
            }

            $scope.applyMultiPrice = function (val) {
                if (val > 0) {
                    $scope.ClickedRow.UnitPrice = val;
                    $scope.click($scope.ClickedRow, 1);
                }
                $('#multiPriceModal').modal('hide');
            }

            $scope.updateCashCredit = function () {

                if (!$scope.ISalesInvoice.Id > 0) {
                    if ($scope.ISalesInvoice.PaymentType == "" || $scope.ISalesInvoice.PaymentType == null) {
                        $scope.ISalesInvoice.PaymentType = $scope.VoucherSet.PaymentType;
                        if ($scope.ISalesInvoice.PaymentType == "" || $scope.ISalesInvoice.PaymentType == null) {
                            $scope.ISalesInvoice.PaymentType = "CREDIT";
                        }
                    }

                    $scope.ISalesInvoice.CashAmount = 0;
                    $scope.ISalesInvoice.CreditAmount = 0;
                    $scope.ISalesInvoice.CardAmount = 0;
                    if ($scope.ISalesInvoice.PaymentType == "ALL") {
                        $scope.ISalesInvoice.CashAmount = $scope.ISalesInvoice.GrandTotal / 3;
                        $scope.ISalesInvoice.CreditAmount = $scope.ISalesInvoice.GrandTotal / 3;
                        $scope.ISalesInvoice.CardAmount = $scope.ISalesInvoice.GrandTotal / 3;
                    }
                    if ($scope.ISalesInvoice.PaymentType == "CASH") {
                        $scope.ISalesInvoice.CashAmount = $scope.ISalesInvoice.GrandTotal;
                        $scope.ISalesInvoice.CreditAmount = 0;
                        $scope.ISalesInvoice.CardAmount = 0;
                    }
                    if ($scope.ISalesInvoice.PaymentType == "CREDIT") {
                        $scope.ISalesInvoice.CreditAmount = $scope.ISalesInvoice.GrandTotal;
                        $scope.ISalesInvoice.CashAmount = 0;
                        $scope.ISalesInvoice.CardAmount = 0;
                    }
                    if ($scope.ISalesInvoice.PaymentType == "CARD") {
                        $scope.ISalesInvoice.CardAmount = $scope.ISalesInvoice.GrandTotal;
                        $scope.ISalesInvoice.CashAmount = 0;
                        $scope.ISalesInvoice.CreditAmount = 0;
                    }
                    if ($scope.ISalesInvoice.PaymentType == "CASH CREDIT") {
                        $scope.ISalesInvoice.CashAmount = $scope.ISalesInvoice.GrandTotal / 2;
                        $scope.ISalesInvoice.CreditAmount = $scope.ISalesInvoice.GrandTotal / 2;
                        $scope.ISalesInvoice.CardAmount = 0;
                    }
                    if ($scope.ISalesInvoice.PaymentType == "CASH CARD") {
                        $scope.ISalesInvoice.CashAmount = $scope.ISalesInvoice.GrandTotal / 2;
                        $scope.ISalesInvoice.CardAmount = $scope.ISalesInvoice.GrandTotal / 2;
                        $scope.ISalesInvoice.CreditAmount = 0;
                    }
                    if ($scope.ISalesInvoice.PaymentType == "CARD CREDIT") {
                        $scope.ISalesInvoice.CardAmount = $scope.ISalesInvoice.GrandTotal / 2;
                        $scope.ISalesInvoice.CreditAmount = $scope.ISalesInvoice.GrandTotal / 2;
                        $scope.ISalesInvoice.CashAmount = 0;
                    }
                }
            }

            $scope.IsSavePrint = false;
            $scope.SaveVocuher = function (pval) {

                $scope.IsSavePrint = false;
                if (pval == 2) {
                    $scope.IsSavePrint = true;
                }

                $scope.ISalesInvoice.IsRevision = false;
                if (pval == 3) {
                    $scope.ISalesInvoice.IsRevision = true;
                }

                var errVal = $scope.validateVoucher();

                if ($scope.ErrorText == "") {

                    if ($scope.VoucherSet.IsEnableCashCredit) {
                        $('#cashcardModal').modal('show');
                    } else {
                        $('#saveModal').modal('show');
                    }

                } else {
                    toastr.warning($scope.ErrorText);
                }

            }

             $scope.checkPaymentAuto = function (temp) {
                if ($scope.ISalesInvoice.PaymentType == "CASH CREDIT") {
                    if (temp == "Credit") {
                        $scope.ISalesInvoice.CashAmount = $scope.ISalesInvoice.GrandTotal - $scope.ISalesInvoice.CreditAmount;
                    }
                    if (temp == "Cash") {
                        $scope.ISalesInvoice.CreditAmount = $scope.ISalesInvoice.GrandTotal - $scope.ISalesInvoice.CashAmount;
                    }
                } else if ($scope.ISalesInvoice.PaymentType == "CASH CARD") {
                    if (temp == "Card") {
                        $scope.ISalesInvoice.CashAmount = $scope.ISalesInvoice.GrandTotal - $scope.ISalesInvoice.CardAmount;
                    }
                    if (temp == "Cash") {
                        $scope.ISalesInvoice.CardAmount = $scope.ISalesInvoice.GrandTotal - $scope.ISalesInvoice.CashAmount;
                    }
                } else if ($scope.ISalesInvoice.PaymentType == "CARD CREDIT") {
                    if (temp == "Credit") {
                        $scope.ISalesInvoice.CardAmount = $scope.ISalesInvoice.GrandTotal - $scope.ISalesInvoice.CreditAmount;
                    }
                    if (temp == "Card") {
                        $scope.ISalesInvoice.CreditAmount = $scope.ISalesInvoice.GrandTotal - $scope.ISalesInvoice.CardAmount;
                    }
                }
            }


            $scope.validateCashCredit = function () {

                 $scope.ErrorText = "";
                var tot = $scope.ISalesInvoice.CardAmount + $scope.ISalesInvoice.CreditAmount + $scope.ISalesInvoice.CashAmount;
                if(tot != $scope.ISalesInvoice.GrandTotal){
                    $scope.ErrorText = "Payment configuration not matching with Grand total";
                }

                if ($scope.ErrorText == "") {
                    $('#cashcardModal').modal('hide');
                    $('#saveModal').modal('show');
                } else {
                    toastr.warning($scope.ErrorText);
                }
            }


            $scope.validateVoucher = function () {

                $scope.ErrorText = "";

                if (!$scope.PageAccessInfo.IsAdd && !$scope.ISalesInvoice.Id > 0) {
                    $scope.ErrorText = "You Dont Have Access To Add Data, Please Contact Admin";
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.ISalesInvoice.Id > 0) {
                    $scope.ErrorText = "You Dont Have Access To Edit Data, Please Contact Admin";
                }

                if ($scope.IsValidFinYear == false) {
                    $scope.ErrorText = "Operation Not Possible, Current Financial Year Closed.";
                }

                if ($scope.VoucherSet.IsSaveWithLinking == true && !$scope.IsLinkedScreen && !$scope.ISalesInvoice.Id > 0) {
                    $scope.ErrorText = "Linking Not Found. Please Link Voucher.";
                }

                if (!$scope.ISalesInvoice.VoucherNumber.length > 0) {
                    $scope.ErrorText = "Please Enter Voucher No.";
                }

                if ($scope.VDesign != null) {
                    if ($scope.VoucherDocs.length == 0 && $scope.VDesign.IsAttachmentMandatory) {
                        $scope.ErrorText = "Attachment Missing";
                    }
                }

                var headErr = VoucherValidationService.validateVoucherHeader($scope.ISalesInvoice, $scope.VDesign, $scope.CompanyProfile);
                if (headErr != "" && headErr != undefined && headErr != null) {
                    $scope.ErrorText = headErr;
                }

                var count = 0;
                var count2 = 0;
                var balanceValidation = "";
                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {

                    if (e.ProductId > 0) {
                        var bodyErr = VoucherValidationService.validateVoucherBody(e, $scope.VDesign, $scope.CompanyProfile, $scope.IsRemarksSmall);
                        if (bodyErr != "" && bodyErr != undefined && bodyErr != null) {
                            $scope.ErrorText = bodyErr;
                        }
                    }

                    if (e.ProductId > 0 && $scope.VoucherSet.IsWarnNegativeStock) {
                        if (e.Product.Balance <= 0) {
                            balanceValidation = balanceValidation + " -  " + e.Product.Name;
                        }
                    }


                    if (!$scope.VoucherSet.AllowZeroCost) {
                        if (e.ProductId > 0 && e.Total <= 0) {
                            count = count + 1;
                        }
                        if (e.ProductId == "" && e.Total > 0) {
                            count = count + 1;
                        }
                    }

                    if (e.ProductId == "" && e.Total == 0) {
                        count2 = count2 + 1;
                    }

                    if (e.ProductId > 0) {
                        e.SalesQuotationCosts = [];
                        angular.forEach(e.CostCenters, function (a) {
                            if (a.Section == "Body") {
                                if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                    $scope.ErrorText = "Cost Center Not Selected For : " + a.CostCenter.Name;
                                } else {
                                    if (a.SelectedCostCenterId > 0) {
                                        var cst = {
                                            CostCenterId: a.SelectedCostCenterId,
                                        }
                                        e.SalesQuotationCosts.push(cst);
                                        console.log(e);
                                    }
                                }
                            }
                        })
                    }

                    if (e.Cost > e.UnitPrice && $scope.VDesign.IsDCost && $scope.VoucherSet.IsCostValidation) {
                        $scope.ErrorText = "Cost is more than rate  - " + e.Product.Name;
                    }

                });

                $scope.ISalesInvoice.SalesQuotationCosts = [];
                angular.forEach($scope.CostCenters, function (e) {
                    if (e.Section == "Head") {
                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                            $scope.ErrorText = "Cost Center Not Selected For : " + e.CostCenter.Name;
                        } else {
                            if (e.SelectedCostCenterId > 0) {
                                var cst = {
                                    CostCenterId: e.SelectedCostCenterId,
                                }
                                $scope.ISalesInvoice.SalesQuotationCosts.push(cst);
                            }
                        }
                    }
                })



                if (balanceValidation != "") {
                    $scope.OpenCustomMessageModal("Negative Balance Found For " + balanceValidation);
                }


                if ($scope.ISalesInvoice.CustomerId == "" && $scope.ISalesInvoice.Customer == undefined) {
                    $scope.ErrorText = "Please Select/ Enter Customer ";
                } else if ($scope.ISalesInvoice.CustomerId == "" && $scope.ISalesInvoice.Customer.MobileNo == "") {
                    $scope.ErrorText = "Please Enter Customer No";
                } else if (count > 0) {
                    $scope.ErrorText = "Invalid Details";
                } else if (count2 == $scope.ISalesInvoice.SalesQuotationDetails.length) {
                    $scope.ErrorText = "Invalid Details";
                }

                return true;

            };

            $scope.SaveWithConfirm = function () {

                 if ($scope.ISalesInvoice.IsForceSave == undefined || $scope.ISalesInvoice.IsForceSave == null) {
                $scope.ISalesInvoice.IsForceSave = false;
            }

                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.ISalesInvoice.DateString = $scope.extractDate($scope.ISalesInvoice.Date);
                if ($scope.ISalesInvoice.DeliveryDate != null) {
                    $scope.ISalesInvoice.DelDateString = $scope.extractDate($scope.ISalesInvoice.DeliveryDate);
                }
                if ($scope.ISalesInvoice.ReturnDate != null) {
                    $scope.ISalesInvoice.RetDateString = $scope.extractDate($scope.ISalesInvoice.ReturnDate);
                }
                if ($scope.ISalesInvoice.SupplierBillDate != null) {
                    $scope.ISalesInvoice.SupDateString = $scope.extractDate($scope.ISalesInvoice.SupplierBillDate);
                }
                if ($scope.ISalesInvoice.Field16 != null) {
                    $scope.ISalesInvoice.F16DateString = $scope.extractDate($scope.ISalesInvoice.Field16);
                }
                if ($scope.ISalesInvoice.Field17 != null) {
                    $scope.ISalesInvoice.F17DateString = $scope.extractDate($scope.ISalesInvoice.Field17);
                }
                if ($scope.ISalesInvoice.Field18 != null) {
                    $scope.ISalesInvoice.F18DateString = $scope.extractDate($scope.ISalesInvoice.Field18);
                }
                if ($scope.ISalesInvoice.Field19 != null) {
                    $scope.ISalesInvoice.F19DateString = $scope.extractDate($scope.ISalesInvoice.Field19);
                }
                if ($scope.ISalesInvoice.Field20 != null) {
                    $scope.ISalesInvoice.F20DateString = $scope.extractDate($scope.ISalesInvoice.Field20);
                }

                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {

                    if (e.Field16 != null) {
                        e.F16DateString = $scope.extractDate(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.F17DateString = $scope.extractDate(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.F18DateString = $scope.extractDate(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.F19DateString = $scope.extractDate(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.F20DateString = $scope.extractDate(e.Field20);
                    }

                });

                var VoucherData = angular.copy($scope.ISalesInvoice);
                angular.forEach(VoucherData.SalesQuotationDetails, function (e, index) {
                    e.CostCenters = [];
                    e.Order = index;
                })
                VoucherData.VoucherExtraTables = $scope.VoucherExtraTables;
                VoucherData.VoucherDocs = $scope.VoucherDocs;

                MainService.AddSalesQuotation(VoucherData).then(function (response) {
                    if (response.data.Message == "Success") {
                        $scope.Load = false;
                        toastr.success("Success");
                        $('#saveModal').modal('hide');
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, 'Sales Quotation', $scope.ISalesInvoice.VoucherNumber);
                        }
                        $scope.refreshpageSave();

                    } else {
                        $scope.Load = false;
                        toastr.warning(response.data.Message);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                });

            }

            $scope.refreshpageSave = function () {

                if ($stateParams.LinkVoucherId > 0 || $stateParams.VoucherId > 0) {
                    if ($scope.VoucherSet.IsLoadVouhcerAfterSave && $stateParams.LinkVoucherId > 0) {
                        $scope.setVoucherPreLoads($scope.VoucherSet.IsLoadPendingAfterSave);
                        $state.go($scope.VoucherSet.VouhcerAfterSaveName);
                    } else {
                        $state.go("SalesQuotation");
                    }
                } else {
                    $scope.init();
                }

            }


            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $('#deleteModal').modal('show');

                }
            }

            $scope.deleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteSalesQuotation($scope.ISalesInvoice.Id).then(function (response) {
                    if (response.data.Message == "Success") {
                        toastr.success("Success");
                        $('#deleteModal').modal('hide');
                        $state.go("SalesQuotation");
                        $scope.init();
                    } else {
                        toastr.warning(response.data.Message);
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })

            }




            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }


            $scope.deleteRow = function () {

                var isLinked = false;

                if ($scope.ISalesInvoice.LinkedRefNos == null) {
                    isLinked = false;
                } else if ($scope.ISalesInvoice.LinkedRefNos.length > 0) {
                    isLinked = true;
                }

                if (isLinked && $scope.VDesign.SkipVoucherLinkValidation == false) {
                    toastr.info("Linked Vouchers, Operation Not Permitted");
                } else {

                    var index = $scope.ISalesInvoice.SalesQuotationDetails.indexOf($scope.ClickedRow);
                    $scope.ISalesInvoice.SalesQuotationDetails.splice(index, 1);

                    $scope.CalculateTotals();

                }

            }


            $scope.LoadFromChartHead = function () {
                if ($scope.CompanyProfile.IsPriceChart) {
                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (row) {
                        if (row.ProductId > 0) {

                            var array = [];
                            array.push(row);


                            var CommonVoucherCosts = [];
                            array[0].CommonVoucherCosts = [];

                            angular.forEach($scope.CostCenters, function (e) {
                                if (e.Section == "Head") {
                                    if (e.IsMandatory && !e.SelectedCostCenterId > 0) {} else {
                                        if (e.SelectedCostCenterId > 0) {
                                            var cst = {
                                                CostCenterId: e.SelectedCostCenterId,
                                            }
                                            CommonVoucherCosts.push(cst);
                                        }
                                    }
                                }
                            })

                            angular.forEach(array, function (a) {
                                angular.forEach(a.CostCenters, function (e) {
                                    if (e.Section == "Body") {
                                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {} else {
                                            if (e.SelectedCostCenterId > 0) {
                                                var cst = {
                                                    CostCenterId: e.SelectedCostCenterId,
                                                }
                                                CommonVoucherCosts.push(cst);
                                            }
                                        }
                                    }
                                })
                            })

                            var temp = {
                                CommonVoucherDetails: array,
                                CustomerId: $scope.ISalesInvoice.CustomerId,
                                CommonVoucherCosts: CommonVoucherCosts,
                            }


                            MainService.LoadPriceFromChart(temp).then(function (response) {
                                if (response.data != null && response.data != "") {
                                    row.UnitPrice = response.data.SellPrice;
                                    row.ExtraCharges = response.data.Commission;
                                    if (response.data.Cost > 0) {
                                        row.Cost = response.data.Cost;
                                        row.COGS = response.data.Cost;
                                    }
                                    $scope.click(row, 2);
                                } else {}
                            }, function (err) {})
                        } else {}

                    })
                }

            }


            $scope.LoadFromChart = function (ttt) {
                if ($scope.CompanyProfile.IsPriceChart) {

                    if (ttt == 0) {


                        if ($scope.ClickedRow.ProductId > 0) {

                            $.LoadingOverlay("show", {
                                image: "images/load.gif",
                            });

                            var array = [];
                            array.push($scope.ClickedRow);


                            var CommonVoucherCosts = [];
                            array[0].CommonVoucherCosts = [];

                            angular.forEach($scope.CostCenters, function (e) {
                                if (e.Section == "Head") {
                                    if (e.IsMandatory && !e.SelectedCostCenterId > 0) {} else {
                                        if (e.SelectedCostCenterId > 0) {
                                            var cst = {
                                                CostCenterId: e.SelectedCostCenterId,
                                            }
                                            CommonVoucherCosts.push(cst);
                                        }
                                    }
                                }
                            })

                            angular.forEach(array, function (a) {
                                angular.forEach(a.CostCenters, function (e) {
                                    if (e.Section == "Body") {
                                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {} else {
                                            if (e.SelectedCostCenterId > 0) {
                                                var cst = {
                                                    CostCenterId: e.SelectedCostCenterId,
                                                }
                                                CommonVoucherCosts.push(cst);
                                            }
                                        }
                                    }
                                })
                            })

                            var temp = {
                                CommonVoucherDetails: array,
                                CustomerId: $scope.ISalesInvoice.CustomerId,
                                CommonVoucherCosts: CommonVoucherCosts,
                            }


                            MainService.LoadPriceFromChart(temp).then(function (response) {
                                if (response.data != null && response.data != "") {
                                    $scope.ClickedRow.UnitPrice = response.data.SellPrice;
                                    $scope.ClickedRow.ExtraCharges = response.data.Commission;
                                    if (response.data.Cost > 0) {
                                        $scope.ClickedRow.Cost = response.data.Cost;
                                        $scope.ClickedRow.COGS = response.data.Cost;
                                    }
                                } else {
                                    toastr.warning("Combinations Not Available");
                                }
                                $scope.click($scope.ClickedRow, 2);
                            }, function (err) {
                                toastr.error("Network Error");
                                $scope.click($scope.ClickedRow, 2);
                            })
                            $.LoadingOverlay("hide");
                        } else {
                            $.LoadingOverlay("hide");
                            toastr.warning("Select Product");
                            $scope.click($scope.ClickedRow, 2);
                        }

                    } else {
                        if ($scope.SelectedCE.ProductId > 0) {



                            var array = [];
                            array.push($scope.SelectedCE);


                            var CommonVoucherCosts = [];
                            array[0].CommonVoucherCosts = [];

                            angular.forEach($scope.CostCenters, function (e) {
                                if (e.Section == "Head") {
                                    if (e.IsMandatory && !e.SelectedCostCenterId > 0) {} else {
                                        if (e.SelectedCostCenterId > 0) {
                                            var cst = {
                                                CostCenterId: e.SelectedCostCenterId,
                                            }
                                            CommonVoucherCosts.push(cst);
                                        }
                                    }
                                }
                            })

                            angular.forEach(array, function (a) {
                                angular.forEach(a.CostCenters, function (e) {
                                    if (e.Section == "Body") {
                                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {} else {
                                            if (e.SelectedCostCenterId > 0) {
                                                var cst = {
                                                    CostCenterId: e.SelectedCostCenterId,
                                                }
                                                CommonVoucherCosts.push(cst);
                                            }
                                        }
                                    }
                                })
                            })

                            var temp = {
                                CommonVoucherDetails: array,
                                CustomerId: $scope.ISalesInvoice.CustomerId,
                                CommonVoucherCosts: CommonVoucherCosts,
                            }


                            MainService.LoadPriceFromChart(temp).then(function (response) {
                                if (response.data != null && response.data != "") {
                                    $scope.SelectedCE.UnitPrice = response.data.SellPrice;
                                    $scope.SelectedCE.ExtraCharges = response.data.Commission;
                                    if (response.data.Cost > 0) {
                                        $scope.SelectedCE.Cost = response.data.Cost;
                                        $scope.SelectedCE.COGS = response.data.Cost;
                                    }
                                }
                                $scope.click($scope.SelectedCE, 2);
                            }, function (err) {
                                $scope.click($scope.SelectedCE, 2);
                            })
                        } else {
                            $scope.click($scope.SelectedCE, 2);
                        }
                    }

                } else {
                    $scope.click($scope.ClickedRow, 2);
                }
            }

            $scope.ApplyUnit = function () {
                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                    if (e.ProductId > 0) {
                        e.UnitId = $scope.ClickedRow.UnitId;
                        $scope.click(e, 2);
                    }
                });
            }

            $scope.ApplyVat = function () {
                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                    if (e.ProductId > 0) {
                        e.VATId = $scope.ClickedRow.VATId;
                        $scope.click(e, 2);
                    }
                });
            }

            $scope.AnalysePrice = function (temp) {


                if ($scope.ClickedRow.ProductId > 0) {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AnalysePreviousSQPrice($scope.ClickedRow.ProductId, $scope.ISalesInvoice.CustomerId, temp).then(function (response) {
                        if (response.data) {
                            $scope.AnalysisItems = response.data;
                            $('#analysismodal').modal('show');
                        }
                    }, function (err) {
                        toastr.error("Network Error");
                    })
                    $.LoadingOverlay("hide");
                } else {
                    $.LoadingOverlay("hide");
                    toastr.warning("Select Product And Custoemr");
                }

            }

            $scope.applyAnalysPrice = function (data) {
                $scope.ClickedRow.UnitPrice = data.UnitPrice;
                $scope.click($scope.ClickedRow, 2);
                $('#analysismodal').modal('hide');
            }



            $scope.GetBackSalesQuotation = function (type) {
                var temp = 0;
                if ($scope.ISalesInvoice.Id > 0) {
                    temp = $scope.ISalesInvoice.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackSalesQuotation(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.ApplyVatCostCenters = function (data) {

                angular.forEach($scope.CostCenters, function (e) {
                    if (e.CostCenter.Id == $scope.CompanyProfile.CostCenterCountryId) {
                        e.SelectedCostCenterId = data.CostCenterCountryId;
                    } else if (e.CostCenter.Id == $scope.CompanyProfile.CostCenterStateId) {
                        e.SelectedCostCenterId = data.CostCenterStateId;
                    } else if (e.CostCenter.Id == $scope.CompanyProfile.CostCenterTaxCategoryId) {
                        e.SelectedCostCenterId = data.CostCenterTaxCategoryId;
                    } else if (e.CostCenter.Id == $scope.CompanyProfile.CostCenterVatAccountTypeId) {
                        e.SelectedCostCenterId = data.CostCenterVatAccountTypeId;
                    }
                })

            }

            $scope.$on('refreshCostCenterDir', function (e, id) {
                angular.forEach($scope.CostCenters, function (cost) {
                    if (cost.CostCenterId == id) {
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.CostCenterSubList(id).then(function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    })
                                })
                            }
                            $.LoadingOverlay("hide");
                        }, function () {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        })
                    }
                })
            });







            $scope.FieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Sales Quotation";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.FieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.ISalesInvoice.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.ISalesInvoice.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.ISalesInvoice.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.ISalesInvoice.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.ISalesInvoice.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };


            $scope.ManufAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Manufacturing",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.ManufStockAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.ManufAutocompleteDataSource2 = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Stock",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.ManufStockAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.ManufAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Manufacturing",
                dataTextField: "Manufacturing",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Manufacturing = data.Manufacturing;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ManufAutocompleteDataSource
            };
            $scope.StockAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Stock",
                dataTextField: "Stock",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Stock = data.Stock;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ManufAutocompleteDataSource2
            };

            $scope.DFieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Sales Quotation";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoCompleteDetail(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.D11AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D12AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D13AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D14AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D15AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };



            $scope.DistributionOther = function (data) {



                if ($scope.VoucherSet.DistributionType == "Quantity") {
                    var totalvalue = 0;
                    var amount = angular.copy(data.OtherCharges);

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        totalvalue = totalvalue + e.Quantity;
                    });


                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.percentageval = (e.Quantity / totalvalue) * 100;
                            e.percentageval = $scope.roundOffValue(e.percentageval);
                            console.log(e.percentageval);
                        }
                    });

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.OtherCharges = amount * (e.percentageval / 100);
                            e.OtherCharges = $scope.roundOffValue(e.OtherCharges);
                            $scope.click(e, 2);
                        }
                    });


                } else if ($scope.VoucherSet.DistributionType == "Unit Price") {
                    var totalvalue = 0;
                    var amount = angular.copy(data.OtherCharges);

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        totalvalue = totalvalue + e.UnitPrice;
                    });


                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.percentageval = (e.UnitPrice / totalvalue) * 100;
                            e.percentageval = $scope.roundOffValue(e.percentageval);
                            console.log(e.percentageval);
                        }
                    });

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.OtherCharges = amount * (e.percentageval / 100);
                            e.OtherCharges = $scope.roundOffValue(e.OtherCharges);
                            $scope.click(e, 2);
                        }
                    });


                } else {

                    // by value
                    var totalvalue = 0;
                    var amount = angular.copy(data.OtherCharges);

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        totalvalue = totalvalue + (e.Quantity * e.UnitPrice);
                    });


                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.percentageval = ((e.Quantity * e.UnitPrice) / totalvalue) * 100;
                            e.percentageval = $scope.roundOffValue(e.percentageval);
                            console.log(e.percentageval);
                        }
                    });

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.OtherCharges = amount * (e.percentageval / 100);
                            e.OtherCharges = $scope.roundOffValue(e.OtherCharges);
                            $scope.click(e, 2);
                        }
                    });

                }

            }

            $scope.DistributionExtra = function (data) {



                if ($scope.VoucherSet.DistributionType == "Quantity") {
                    var totalvalue = 0;
                    var amount = angular.copy(data.ExtraCharges);

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        totalvalue = totalvalue + e.Quantity;
                    });


                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.percentageval = (e.Quantity / totalvalue) * 100;
                            e.percentageval = $scope.roundOffValue(e.percentageval);
                            console.log(e.percentageval);
                        }
                    });

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.ExtraCharges = amount * (e.percentageval / 100);
                            e.ExtraCharges = $scope.roundOffValue(e.ExtraCharges);
                            $scope.click(e, 2);
                        }
                    });


                } else if ($scope.VoucherSet.DistributionType == "Unit Price") {
                    var totalvalue = 0;
                    var amount = angular.copy(data.ExtraCharges);

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        totalvalue = totalvalue + e.UnitPrice;
                    });


                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.percentageval = (e.UnitPrice / totalvalue) * 100;
                            e.percentageval = $scope.roundOffValue(e.percentageval);
                            console.log(e.percentageval);
                        }
                    });

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.ExtraCharges = amount * (e.percentageval / 100);
                            e.ExtraCharges = $scope.roundOffValue(e.ExtraCharges);
                            $scope.click(e, 2);
                        }
                    });


                } else {

                    // by value
                    var totalvalue = 0;
                    var amount = angular.copy(data.ExtraCharges);

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        totalvalue = totalvalue + (e.Quantity * e.UnitPrice);
                    });


                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.percentageval = ((e.Quantity * e.UnitPrice) / totalvalue) * 100;
                            e.percentageval = $scope.roundOffValue(e.percentageval);
                            console.log(e.percentageval);
                        }
                    });

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.ExtraCharges = amount * (e.percentageval / 100);
                            e.ExtraCharges = $scope.roundOffValue(e.ExtraCharges);
                            $scope.click(e, 2);
                        }
                    });

                }

            }

            $scope.DistributionDiscount = function (data) {



                if ($scope.VoucherSet.DistributionType == "Quantity") {
                    var totalvalue = 0;
                    var amount = angular.copy(data.Discount);

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        totalvalue = totalvalue + e.Quantity;
                    });


                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.percentageval = (e.Quantity / totalvalue) * 100;
                            e.percentageval = $scope.roundOffValue(e.percentageval);
                            console.log(e.percentageval);
                        }
                    });

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.Discount = amount * (e.percentageval / 100);
                            e.Discount = $scope.roundOffValue(e.Discount);
                            $scope.click(e, 2);
                        }
                    });


                } else if ($scope.VoucherSet.DistributionType == "Unit Price") {
                    var totalvalue = 0;
                    var amount = angular.copy(data.Discount);

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        totalvalue = totalvalue + e.UnitPrice;
                    });


                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.percentageval = (e.UnitPrice / totalvalue) * 100;
                            e.percentageval = $scope.roundOffValue(e.percentageval);
                            console.log(e.percentageval);
                        }
                    });

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.Discount = amount * (e.percentageval / 100);
                            e.Discount = $scope.roundOffValue(e.Discount);
                            $scope.click(e, 2);
                        }
                    });


                } else {

                    // by value
                    var totalvalue = 0;
                    var amount = angular.copy(data.Discount);

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        totalvalue = totalvalue + (e.Quantity * e.UnitPrice);
                    });


                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.percentageval = ((e.Quantity * e.UnitPrice) / totalvalue) * 100;
                            e.percentageval = $scope.roundOffValue(e.percentageval);
                            console.log(e.percentageval);
                        }
                    });

                    angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                        if (e.UnitPrice > 0 && e.Quantity > 0) {
                            e.Discount = amount * (e.percentageval / 100);
                            e.Discount = $scope.roundOffValue(e.Discount);
                            $scope.click(e, 2);
                        }
                    });

                }

            }



            /////////////////// FILE UPLOAD //////////////////

            $scope.calculateExcel = function (tempArr) {
                var length = tempArr.length;
                var number = 0;
                $scope.ISalesInvoice.SalesQuotationDetails = [];
                var Details = [];

                angular.forEach(tempArr, function (ttp) {
                    var pro = {
                        Code: ttp.ProductCode,
                        Name: ttp.ProductName,
                    }

                    MainService.getProductByName(pro).then(function (response) {
                        if (response.data) {

                            number = number + 1;

                            var row = {

                                Discount: ttp.Discount,
                                ClearingCharges: ttp.ClearingCharges,
                                CustomDuty: ttp.CustomDuty,
                                DeliveryCharges: ttp.DeliveryCharges,
                                OtherCharges: ttp.OtherCharges,
                                FreightCharges: ttp.FreightCharges,
                                ExtraCharges: ttp.ExtraCharges,
                                PackingCharges: ttp.PackingCharges,

                                Quantity: ttp.Quantity,
                                UnitPrice: ttp.UnitPrice,
                                remarks: ttp.Description,
                                Remarks: ttp.Description,

                                ProductId: response.data.Id,
                                Product: response.data,

                                Balance: response.data.Balance,
                                AveragePrice: response.data.AveragePrice,
                                ProductId: response.data.Id,
                                UnitId: response.data.UnitId,
                                CountryId: response.data.CountryId,
                                BrandId: response.data.BrandId,
                                Cost: response.data.AveragePrice,
                                COGS: response.data.AveragePrice,
                                NetWeight: response.data.Weight,
                                GrossWeight: response.data.GrossWeight,
                                Field9: response.data.Field9,
                            }

                            if (row.Discount == undefined || Number.isNaN(row.Discount)) {
                                row.Discount = 0;
                            }
                            if (row.ClearingCharges == undefined || Number.isNaN(row.ClearingCharges)) {
                                row.ClearingCharges = 0;
                            }
                            if (row.CustomDuty == undefined || Number.isNaN(row.CustomDuty)) {
                                row.CustomDuty = 0;
                            }
                            if (row.DeliveryCharges == undefined || Number.isNaN(row.DeliveryCharges)) {
                                row.DeliveryCharges = 0;
                            }
                            if (row.OtherCharges == undefined || Number.isNaN(row.OtherCharges)) {
                                row.OtherCharges = 0;
                            }
                            if (row.FreightCharges == undefined || Number.isNaN(row.FreightCharges)) {
                                row.FreightCharges = 0;
                            }
                            if (row.ExtraCharges == undefined || Number.isNaN(row.ExtraCharges)) {
                                row.ExtraCharges = 0;
                            }
                            if (row.PackingCharges == undefined || Number.isNaN(row.PackingCharges)) {
                                row.PackingCharges = 0;
                            }
                            if (row.DiscountValue == undefined || Number.isNaN(row.DiscountValue)) {
                                row.DiscountValue = 0;
                            }

                            if (ttp.VatPer != null && ttp.VatPer != undefined) {
                                angular.forEach($scope.VATs, function (a) {
                                    if (a.Value == ttp.VatPer) {
                                        row.VATId = a.Id;
                                    }
                                });
                            } else {
                                row.VATId = response.data.VATId;
                            }

                            if (ttp.VatType != null && ttp.VatType != undefined) {
                                row.VatType = ttp.VatType;
                            } else {
                                row.VatType = response.data.VatType;
                            }

                            angular.forEach($scope.Warehouses, function (a) {
                                if (a.Name == ttp.WarehouseName) {
                                    row.WarehouseId = a.Id;
                                }
                            });


                            Details.push(row);

                            if (length == number) {
                                $scope.ISalesInvoice.SalesQuotationDetails = Details;
                                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                                    $scope.click(e, 1);
                                })
                            }


                        } else {
                            toastr.warning("Product Not Found" + ttp.ProductName);
                        }
                    }, function () {
                        toastr.error("Network Error");
                    })
                })
            }

            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                $scope.ISalesInvoice.SalesQuotationDetails = [];

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);

                        var tempArr = [];
                        $scope.ISalesInvoice.SalesQuotationDetails = [];

                        angular.forEach(oJS, function (e) {

                            var ttp = {
                                Quantity: parseFloat(e.Quantity),
                                UnitPrice: parseFloat(e.UnitPrice),
                                Total: parseFloat(e.Quantity) * parseFloat(e.UnitPrice),
                                Discount: parseFloat(e.Discount),
                                OtherCharges: parseFloat(e.OtherCharges),
                                ExtraCharges: parseFloat(e.ExtraCharges),
                                FreightCharges: parseFloat(e.FreightCharges),
                                PackingCharges: parseFloat(e.PackingCharges),
                                ClearingCharges: parseFloat(e.ClearingCharges),
                                CustomDuty: parseFloat(e.CustomDuty),
                                DeliveryCharges: parseFloat(e.DeliveryCharges),
                                remarks: e.Description,
                                Remarks: e.Description,
                                ProductCode: e.ProductCode,
                                ProductName: e.ProductName,
                                Product: {
                                    Name: e.ProductName,
                                    ProductCode: e.ProductCode
                                },
                                CostCenters: angular.copy($scope.CostCenters),
                                VatType: e.VatType != undefined && e.VatType != null ? e.VatType : "Exclusive",
                                VatPer: parseFloat(e.VatPer),
                                WarehouseName: e.WarehouseName,
                                DiscountType: "Value",
                                DiscountValue: parseFloat(e.Discount),
                            }

                            tempArr.push(ttp);

                        });

                        $scope.$apply();
                        $scope.calculateExcel(tempArr);

                    });
                };

                reader.readAsBinaryString(oFile);



            }





            $scope.VoucherExtraTables = [];
            $scope.addExtraTableRow = function () {
                var row = {
                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                    Field11: "",
                    Field12: "",
                    Field13: "",
                    Field14: "",
                    Field15: ""
                }
                $scope.VoucherExtraTables.push(row);
            }

            $scope.removeExtraTableRow = function (data) {
                var index = $scope.VoucherExtraTables.indexOf(data);
                $scope.VoucherExtraTables.splice(index, 1);
            }


            /////////////////// Attachment //////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }

            //////////////////////////// History ////////////////////////////

            $scope.GetInvoiceHistory = function () {
                $scope.historyList = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.SalesQuotationHistory($scope.ISalesInvoice.Id).then(function (response) {
                    if (response.data != null) {
                        $scope.historyList = response.data;
                        $('#voucherHistoryModal').modal('show');
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });

            }

            $scope.GetVoucherHistoryPreview = function () {

            }

            $scope.GetInvoiceRevisions = function () {
                $scope.RevisionList = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.SalesQuotationRevisions($scope.ISalesInvoice.Id).then(function (response) {
                    if (response.data != null) {
                        $scope.RevisionList = response.data;
                        $('#voucherRevisionModal').modal('show');
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });

            }


$scope.ApplyDescription = function (row) {
                var Remarks = angular.copy(row.Remarks);
                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                    e.Remarks = Remarks;
                })
            }

             $scope.recalcRows = function () {
                angular.forEach($scope.ISalesInvoice.SalesQuotationDetails, function (e) {
                    if(e.ProductId > 0){
                     $scope.click(e, 1);
                   }
                })
            }

              $scope.ForceSave = function(){
                $scope.ISalesInvoice.IsForceSave = true;
                $scope.SaveVocuher(1);
            }



        }])
